/* globals window */
/* eslint-disable quote-props */
/* eslint-disable angular/window-service */

(function iife() {
	"use strict";

	var common = {
		archiveNoun: "Arkiv",
		createNewExam: "+ Skapa nytt prov",
		exams: "Prov",
		examTemplates: "Provmallar",
		rubrics: "Bedömningsmatriser",
		dateModified: "Datum ändrat",
		startTime: "Starttid",
		title: "Titel",
		cancel: "Avbryt",
		remove: "Ta bort",
		on: "På",
		off: "Av",
		add: "Lägg till",
		edit: "Ändra",
		save: "Spara",
		student: "Elev",
		students: "Elever",
		question: "Fråga",
		questions: "Frågor",
		studentCode: {
			base: "Studentkod",
			new: "Ny Studentkod",
		},
		other: "Annan",
		upload: "Ladda upp",
		errors: {
			invalidEmail: "Ogiltig e-postadress",
		},
	};

	window.DX.locales.sv = {
		"Required": "Obligatorisk",
		"LogIn": "Logga in",
		"CreateAccount": "Skapa konto",
		"ForgotPassword": "Glömt lösenordet?",
		"LogInWithSkolon": "Logga in med Skolon",
		"AboutTheCompany": "Om företaget",
		"TermsOfService": "användarvillkor",
		"PrivacyPolicy": "integritetspolicy",
		"CookiePolicy": "cookiepolicy",
		"RegisterTerms_part1": "Jag godkänner Digiexams ",
		"RegisterDone_part1": "Innan du kan logga in på ditt konto så behöver du verifiera din e-postadress.",
		"RegisterDone_part2": "Öppna länken som skickats till din e-postadress för att verifiera den.",
		"HowWeWorkWithData_Intro": "För en lättläst version om hur vi jobbar med din data, se sidan:",
		"HowWeWorkWithData_LinkTitle": "How we work with data",
		"ChangeRole": "Ändra roll",
		"Overview": "Översikt",
		"Support": "Support",
		"ErrorMessage": "Felmeddelande",
		"Email": "E-postadress",
		"Emails": "E-postadresser",
		"ConfirmEmail": "Bekräfta e-postadress",
		"FirstName": "Förnamn",
		"LastName": "Efternamn",
		"Password": "Lösenord",
		"ConfirmPassword": "Bekräfta lösenord",
		"Back": "Tillbaka",
		"ChoosePlaceToLogin": "Välj plats att logga in på",
		"ChooseAndLogIn": "Välj och logga in",
		"Send": "Skicka",
		"ForgotPassword_String1": "Ange din e-postadress så skickar vi en länk till dig där du kan återställa ditt lösenord.",
		"YourAccountHasBeenCreated": "Ditt konto har skapats",
		"ReturnToLogIn": "Återvänd till inloggningen",
		"SessionExpiredLogInToContinue": "Din session är inte längre giltig. Logga in igen för att fortsätta där du var.",
		"LoginFailed": "Inloggningen misslyckades",
		"LoginFailedDescription": "Inloggningen misslyckades, e-postadress eller lösenord är fel.",
		"LoginFailedDescription.Timeout": "Inloggningsförsöket misslyckades när kontakten med Digiexam servrarna skulle etableras, var god försök igen.",
		"LoginFailedDescription.Throttled": "Du har gjort för många inloggningsförsök under en 3 minutersperiod. Vänta några minuter och försök igen.",
		"PasswordResetLinkHasBeenSent": "Länk för återställning av lösenord skickad",
		"ForgotPasswordLinkRequest_String1": "Om det finns en användare med e-postadressen, skickar vi en länk i ett mail som du öppnar för att välja ett nytt lösenord för ditt konto.",
		"ForgotPasswordLinkRequest_String2": "Du kan behöva titta i din skräppostmapp för att hitta mailet.",
		"ForgotPassword_String3": "Ange ett nytt lösenord för ditt konto.",
		"ForgotPassword_String4": "Du kan nu använda ditt nya lösenord för att logga in på ditt konto.",
		"SetPassword_String3": "Ange ett lösenord för ditt nya konto.",
		"SetPassword_String4": "Du kan nu logga in på ditt konto.",
		"YourAccountIsNowBeingVerified": "Ditt konto blir nu verifierat",
		"ItMightTakeAWhile": "Det kan ta en liten stund, var vänlig vänta.",
		"PleaseWait": "Var vänlig vänta",
		"YourAccountIsNowVerified": "Ditt konto är nu verifierat!",
		"NotVerified": "E-postadress inte verifierad",
		"VerificationError_WrongCode": "Felaktig verifieringskod.",
		"AnErrorHasOccurred": "Ett fel har uppstått",
		"RequiredField": "Nödvändigt fält",
		"MustBeLongerThan1Char": "Måste vara längre än 1 tecken",
		"MustBeLongerThan5Chars": "Måste vara längre än 7 tecken",
		"MustBeValidEmail": "Måste vara en giltig e-postadress",
		"InvalidEmail": common.errors.invalidEmail,
		"EmailsAreNotAMatch": "E-postadresserna matchar inte",
		"YouCantShareToYourOwnMail": "Du kan inte dela till din egen e-postadress",
		"PasswordTooShort": "Lösenordet måste vara minst 8 tecken",
		"PasswordTooLong": "Lösenordet får vara högst 100 tecken",
		"PasswordWhitespace": "Lösenordet får inte innehålla blanka tecken",
		"PasswordsAreNotAMatch": "Lösenorden matchar inte",
		"PasswordCanNotBeOld": "Får inte vara samma som ditt gamla",
		"PasswordCommon": "Lösenordet är inte tillräckligt komplex eller är för vanligt. Försök med något mer unikt",
		"WrongPassword": "Fel lösenord",
		"Optional": "Valfritt",
		"EmailAlreadyRegistered": "E-postadressen är redan registrerad",
		"InviteEmailAlreadyRegistered": "En användare med e-postadressen {0} finns redan registrerad",
		"Overview_String1": "Du har inte gått med i några klasser ännu, klicka på knappen nedan för att göra det.",
		"ShowExamLibrary": "Visa bibliotek",
		"HideExamLibrary": "Dölj bibliotek",
		"YourExams": "Dina prov på {0}",
		"YourExamLibrary": "Ditt provbibliotek",
		"StartNewExam": "Starta nytt prov",
		"InformationBox1": "För att starta ett nytt prov, öppna ",
		"InformationBox2": "Digiexam-appen ",
		"InformationBox3": "på din dator.",
		"Overview.DigiexamDownload": "Ladda ner och installera Digiexam-appen",
		"Overview.DigiexamDownloadButton": "Ladda ner appen",
		"StartClientButton": "Öppna Digiexam-appen PC/Mac",
		"TwoAppsImportantNoteHeader": "Viktig information om applikationsversioner",
		"TwoAppsImportantNoteBody": "Observera att det finns två versioner av applikationen tillgängliga för PC och Mac. Din skola bestämmer vilken version som krävs för prov. På de flesta datorer som hanteras av skolan är den korrekta versionen redan installerad.",
		"StillNeedOldApp": "ELLER använder du en iPad?",
		"StartOldClient": "Öppna iPad-appen",
		"RefreshExamList": "Uppdatera provlistan",
		"Date": "Datum",
		"Course": "Kurs",
		"Courses": "Kurser",
		"Status": "Status",
		"Result": "Resultat",
		"NotPlanned": "Ej planerat",
		"EnterANewClass": "Gå med i en ny klass",
		"ThereAreNoActiveExams": "Det finns inga aktiva prov",
		"UnknownError": "Okänt fel",
		"UnknownErrorTryAgain": "Ett okänt fel uppstod, var god försök igen.",
		"Ok": "Ok",
		"OkIUnderstand": "Ok, jag förstår",
		"ThereAreNoUngradedExams": "Det finns inga orättade prov",
		"ConnectionToServerWasInterrupted": "Anslutningen till servern avbröts",
		"ConnectionError_String1": "Du har tappat anslutningen mot vår server. Detta gör att aktiviteter du arbetar med nu inte kan sparas eller rapporteras in till vår server.",
		"ConnectionError_String2": "Vi ber dig att vara försiktig så att data inte går förlorad.",
		"ConnectionError_String3": "Anledningen till detta avbrott kan vara en av många, men mest troligt är det;",
		"ConnectionError_String4": "Din dator har tappat internetanslutning, kolla om internetkabeln har trillat ur eller kolla om du kan återansluta till det trådlösa nätverket.",
		"ConnectionError_String5": "Något längs med vägen till vår server har gått sönder, vänta och se om anslutningen kommer tillbaka.",
		"ConnectionError_String6": "Vår server har problem med väldigt hög belastning.",
		"ConnectionError_String7": "Du bör inte stänga denna webbläsar-fliken om du vill behålla osparad data du arbetar med. Påkalla istället IT-personals uppmärksamhet och se om dessa kan lösa problemet!",
		"ConnectionError_String8": "Den här rutan kommer att stängas automatiskt när anslutningen till vår server fungerar som normalt igen.",
		"Home": "Hem",
		"Classroom": "Klassrummet",
		"CreateRole": "Skapa roll",
		"AssignRole": "Tilldela roll",
		"LogOut": "Logga ut",
		"Settings": "Inställningar",
		"ChangePersonalData": "Ändra personuppgifter",
		"InformationSaved": "Informationen sparad!",
		"ChangePassword": "Ändra lösenord",
		"SetPassword": "Välj lösenord",
		"Save": common.save,
		"SaveX": "Spara {0}",
		"SaveAndClose": "Spara och stäng",
		"SaveChanges": "Spara ändringarna",
		"YourCurrentPassword": "Ditt nuvarande lösenord",
		"NewPassword": "Nytt lösenord",
		"ConfirmNewPassword": "Bekräfta nytt lösenord",
		"YourPasswordHasBeenChanged": "Ditt lösenord har ändrats!",
		"YourPasswordHasBeenSet": "Ditt lösenord har sparats!",
		"PlanExam": "Planera prov",
		"PlanExams": "Planera prov",
		"ThereAreNoExams": "Det finns inga prov",
		"RemoveExam": "Ta bort prov",
		"RemoveSharedExam": "Ta bort delat prov",
		"RemoveRubric": "Ta bort bedömningsmatris",
		"RemoveGradingShare": "Ta bort din rättningsdelning",
		"DoYouWantToRemoveGradingShareForExam": "Vill du ta bort din rättningsdelning för provet {0}",
		"YesRemoveShare": "Ja, ta bort rättningsdelningen",
		"ThePersonWhoSharedTheExamWillStillHaveAccessToIt": "Personen som delade provet kommer fortfarande att ha tillgång till den.",
		"EditExam": "Redigera prov",
		"UploadOfflineAnswerFile": "Ladda upp offlinesvarsfil",
		"UploadOfflineAnswerFile_Description": "Ladda upp offlinesvarsfiler för elever som inte kunde lämna in sina svar online.",
		"UploadOfflineAnswerFile_FileFormats": "Tillåtna filformat är .zip och .dxr",
		"UploadOfflineAnswerFile_Error": "En eller flera filer kunde inte laddas upp",
		"UploadOfflineAnswerFile_Success": "Alla filer har laddats upp",
		"UploadOfflineAnswerFile_DropOrClickUpload": "Släpp offlinesvarsfiler här eller klicka för att lägga till dem.",
		"UploadOfflineAnswerFile_UnpublishToUpload": "Provet är publicerat, avpublicera provet för att ladda upp offlinesvarsfiler.",
		"Files": "Filer",
		"Filename": "Filnamn",
		"StudentAnswers": "Elevsvar",
		"Students": common.students,
		"Name": "Namn",
		"StudentCode": common.studentCode.base,
		"NewStudentCode": common.studentCode.new,
		"Edit": "Redigera",
		"Monitor": "Övervaka",
		"Schedule": "Schemalägg",
		"Reschedule": "Ändra schemaläggning",
		"Start": "Starta",
		"ShowMoreExamActions": "Visa fler provfunktioner",
		"RemoveStudent": "Ta bort eleven",
		"RemoveStudentFromClass": "Ta bort eleven från klassen",
		"EditStudent": "Redigera elev",
		"EditStudentCode": "Redigera elevkod",
		"NoStudentsHaveRegisteredYet": "Inga elever har registrerats än.",
		"ClassIsExternallyManaged": "Den här klassen är externt hanterad och kan inte modifieras i Digiexam.",
		"ViewClass_String5": "Om klassen inte är aktuell längre kan man skicka den till arkivet.",
		"CouldNotFindClass": "Kunde inte hitta klass",
		"CouldNotFindClassYouSearchedFor": "Kunde inte hitta klassen du sökte.",
		"Archive": "Arkivera",
		"Archive.noun": "Arkiv",
		"Dearchive": "Dearkivera",
		"Group": "Grupp",
		"Class": "Klass",
		"Classes": "Klasser",
		"Hide": "Dölj",
		"Show": "Visa",
		"DoYouReallyWantToDoThis": "Vill du verkligen göra detta?",
		"DoYouWannaRemoveX": "Vill du verkligen ta bort \"{0}\"?",
		"DoYouWannaRemoveExam": "Är du säker på att du vill ta bort provet \"{0}\"? Denna åtgärd kan inte ångras.",
		"DoYouWannaRemoveStudent": "Vill du verkligen ta bort följande elev?",
		"DoYouWannaRemoveStudents": "Vill du verkligen ta bort följande elever?",
		"Confirm": "Bekräfta",
		"Cancel": common.cancel,
		"ArchiveClass": "Arkivera klass",
		"YouCanFindYourArchivedClassesInArchive": "Dina arkiverade klasser hittar du senare i arkivet. Du kan alltid ångra arkiveringen.",
		"ClassWillNowBeDearchived": "Klassen kommer att hamna under dina klasser igen.",
		"DearchiveClass": "Dearkivera klass",
		"YesDearchive": "Ja, dearkivera",
		"NoCancel": "Nej, ångra",
		"Library": "Bibliotek",
		"Subjects": "Ämnen",
		"Type": "Typ",
		"LatestWeek": "Senaste veckan",
		"LatestMonth": "Senaste månaden",
		"LatestYear": "Senaste året",
		"SpecifyDate": "Specifiera datum",
		"From": "Från",
		"To": "Till",
		"Add": common.add,
		"AddX": "Lägg till {0}",
		"NoFiltersActive": "Inga filter tillagda",
		"ClearAllFilters": "Radera alla filter",
		"Clear": "Ta bort",
		"YourLibraryIsEmptyCreateExams": "Du har inte skapat något prov.",
		"YourLibraryIsEmptyCreateRubrics": "Du har inte skapat någon bedömningsmatris.",
		"Between": "Mellan",
		"And": "och",
		"Tag": "tagg",
		"Matching": "matchar",
		"NamelessExam": "Namnlöst prov",
		"NamelessRubric": "Namnlös bedömningsmatris",
		"Preview": "Förhandsgranska",
		"PreviewAndPrint": "Förhandsgranska / Skriv ut",
		"GoToGrading": "Gå till bedömning",
		"ViewResponses": "Granska svar",
		"ReturnToMonitoringView": "Tillbaka till övervakningsvyn",
		"Select": "Välj",
		"SelectThisExam": "Välj detta prov",
		"Question": common.question,
		"Questions": common.questions,
		"QuestionX": "Fråga {0}",
		"Close": "Stäng",
		"YourClasses": "Dina klasser",
		"YourClasses.NoClass": "Du har inte skapat några klasser, skapa en genom att klicka på knappen ovan för att komma igång med planerade prov.",
		"AddQuestion": "Lägg till fråga",
		"CreateExam": "Skapa prov",
		"CreateRubric": "Skapa bedömningsmatris",
		"CreateClass": "Skapa klass",
		"CreateCourse": "Skapa ämne (kurs)",
		"CreateGroup": "Skapa grupp",
		"YourCourses": "Dina kurser",
		"ArchivedClasses": "Arkiverade klasser",
		"FilterClasses": "Filtrera klasserna",
		"FilterCourses": "Filtrera kurserna",
		"ArchivedGroups": "Arkiverade grupper",
		"DragClassHere": "Dra klass hit",
		"Original": "Original",
		"Copy": "Kopia",
		"Draft": "Utkast",
		"CanNotBeEmpty": "Får inte lämnas tomt",
		"CanNotBeLongerThanXChars": "Får inte vara längre än {0} tecken",
		"InputLengthLimitReached": "Du har nått {0}-teckengränsen",
		"Title": common.title,
		"LastModified": "Senast ändrade",
		"LastCreated": "Senast skapade",
		"SortBy": "Sortering",
		"OrderBy": "Sortera efter",
		"PublicExamDescription": "Publik provbeskrivning",
		"PublicExamDescriptionOptional": "Publik provbeskrivning (valfri)",
		"ProfilePicture": "Profilbild",
		"AllowBlank": "Tillåt blankning",
		"AllowSpellcheckForAllStudents": "Tillåt alla studenter att använda stavningskontroll",
		"Saved": "Sparat",
		"SavedHMS": "Sparat ({0}:{1}:{2})",
		"DraftSaved": "Utkast sparat",
		"SaveAsNew": "Spara som ny",
		"NotVisibleToStudents": "Syns inte för eleven",
		"YourOwnNotes": "Egna anteckningar (valfri)",
		"CopyLastQuestion": "Kopiera senaste frågan",
		"MaxLengthsWords": "Max längd (ord)",
		"LimitAnswerLength": "Begränsa svarslängd",
		"NoLimit": "Ingen begränsning",
		"SoftLimit": "Mjuk begränsning",
		"HardLimit": "Hård begränsning",
		"MaxPoints": "Max poäng",
		"GradingInformation": "Rättningsinformation",
		"Subject": "Ämne",
		"TakePartInAClass": "Gå med i en class",
		"EnterCodeTeacherProvided": "Ange koden din lärare angett",
		"EnterCode": "Ange kod",
		"TakePartInClass": "Gå med i klass",
		"YouAreTryingToEnterThisClass": "Du försöker gå med i denna klass",
		"TypeInYourStudentCodeFor": "Skriv in din studentkod för",
		"AndConfirmYourChoice": "och bekräfta sedan ditt val",
		"Accept": "Acceptera",
		"FaultyCode": "Felaktig kod",
		"RemindMeLater": "Påminn mig senare",
		"RegistrationIsClosed": "Registreringen är stängd.",
		"UploadStatus.HandedIn": "Inlämnad",
		"UploadStatus.WrongExam": "Fel prov",
		"UploadStatus.InvalidEmail": common.errors.invalidEmail,
		"UploadStatus.StudentNotFound": "Den här studenten har inget konto än, be en kontohanterare att skapa ett.",
		"ChangeLanguage": "Ändra språk",
		"Language": "Språk",
		"ChooseClass": "Välj aktuell klass",
		"YouHaveNoClassesOrGroupsToManage": "Du har inga klasser eller grupper att hantera.",
		"StopExam": "Stoppa prov",
		"DownloadGradesSpreadsheet": "Ladda ner kalkylblad med betyg",
		"DownloadGradesSpreadsheetIndicateUnanswered": "Ange obesvarade frågor med \" - \"",
		"OpenGrading": "Öppna rättningen",
		"GradeExam": "Rätta prov",
		"For": "För",
		"StartExam": "Starta prov",
		"Tests": "Avstämningar",
		"FinishedExams": "Avklarade prov",
		"ChooseAnotherClass": "Välj annan klass",
		"Locked": "Låst",
		"Unlocked": "Öppet",
		"Yes": "Ja",
		"No": "Nej",
		"NotDigitally": "Ej Digitalt",
		"OngoingExam": "Pågående prov",
		"HaveOpenedExam": "har öppnat provet",
		"HaveSubmitted": "har lämnat in",
		"NotStartedStudents": "Ej startade elever",
		"DoYouWantToEndTheOngoingExam": "Vill du avsluta det pågående provet?",
		"YesEndExam": "Ja, avsluta provet",
		"DeleteExam": "Radera prov",
		"DeleteExams": "Radera markerade prov",
		"DeleteTemplateExam": "Radera provmall",
		"DeleteTemplateExams": "Radera markerade provmallar",
		"AreYouSureToDeleteExam": "Är du säker på att du vill radera det markerade provet?",
		"AreYouSureToDeleteExams": "Är du säker på att du vill radera de markerade proven?",
		"AreYouSureToDeleteTmpExam": "Är du säker på att du vill radera den markerade provmallen?",
		"AreYouSureToDeleteTmpExams": "Är du säker på att du vill radera de markerade provmallarna?",
		"YesDelete": "Ja, radera",
		"NoSubmissionsForGroupExam": "Det finns inga inlämningar för detta prov, avslutar du det så flyttas det till Schemalagda prov.",
		"NoSubmissionsForIdExam": "Det finns inga inlämningar för detta prov, avslutar du det nu så arkiveras det.",
		"ActiveStudents": "Aktiva elever",
		"OfflineStudents": "Offline elever",
		"PenAndPaperStudents": "Papper & penna elever",
		"AbsentStudents": "Frånvarande elever",
		"FilterStudents": "Filtrera elever",
		"Updated": "Uppdaterad",
		"UpdatedEvery20Sec": "uppdateras var 20:e sekund",
		"StudentInformation": "Elevinformation",
		"LockSettings": "Låsinställningar",
		"Actions": "Åtgärder",
		"Started": "Startad",
		"LatestDataReceived": "Senaste inrapportering",
		"TurnedIn": "Inlämnad",
		"StudentStatus": "Elevstatus",
		"LiveView.Status.InProgress": "Pågår",
		"LiveView.Status.Resumed": "Återupptaget",
		"LiveView.Status.CheckStudent": "Anslutningsvarning",
		"LiveView.Status.WorkingOffline": "Arbetar offline",
		"LiveView.Status.Reopened": "Återöppnat",
		"LiveView.Summary.Label": "Klassöversikt",
		"LiveView.Summary.Check": "Anslutningsvarningar",
		"LiveView.Summary.Waiting": "Väntar på att börja",
		"LiveView.Summary.IncludedInProgress": "ingår i antalet pågående prov",
		"LiveView.Summary.Announcement": "Anslutningsvarningar: {0}. Pågår: {1}. Inlämnade: {2} av {3}. Väntar på att börja: {4}.",
		"LiveView.Reason.WaitingToReturn": "Väntar på att eleven ska återvända",
		"LiveView.Reason.UnlockedForReturn": "Upplåst för att fortsätta",
		"LiveView.Reason.NoCurrentUpdates": "Inga aktuella uppdateringar har tagits emot",
		"LiveView.Reason.NoUpdatesAfterReopening": "Inga nya uppdateringar har tagits emot efter återöppningen",
		"LiveView.Reason.NoRecentWork": "Inget arbete har tagits emot nyligen. Senaste aktivitet: {0}",
		"LiveView.Reason.NoContactFor": "Ingen kontakt på {0}",
		"LiveView.Reason.LiveContactUnconfirmed": "Livekontakt är inte bekräftad",
		"LiveView.Reason.LastContact": "Senaste kontakt: {0}",
		"LiveView.Reason.OfflineWork": "Liveuppdateringar förväntas inte",
		"LiveView.Time.Minute": "1 minut",
		"LiveView.Time.Minutes": "{0} minuter",
		"LiveView.Time.Hour": "1 timme",
		"LiveView.Time.Hours": "{0} timmar",
		"LiveView.Time.Day": "1 dag",
		"LiveView.Time.Days": "{0} dagar",
		"LiveView.Time.JustNow": "Nyss",
		"LiveView.Time.Ago": "För {0} sedan",
		"LiveView.Work.HandInTimeUnavailable": "Inlämning mottagen — tid saknas",
		"LiveView.Work.HandInReceived": "Inlämning mottagen",
		"LiveView.Work.TimeUnavailable": "Tid saknas",
		"LiveView.Work.AwaitingHandIn": "Inväntar inlämning",
		"LiveView.Work.AwaitingUpdatedHandIn": "Inväntar uppdaterad inlämning",
		"LiveView.Work.BeforeWorkResumed": "Innan arbetet återupptogs",
		"LiveView.Work.HandInUnconfirmed": "Inlämning är inte bekräftad",
		"LiveView.Work.HandInOrFileNeeded": "Inlämning eller svarsfil behövs",
		"LiveView.Work.NotHandedIn": "Ingen inlämning mottagen",
		"LiveView.Work.NoHandIn": "Ingen inlämning mottagen",
		"LiveView.Work.EarlierHandIn": "Tidigare inlämning mottagen: {0}",
		"LiveView.Work.AnswersReceived": "Senaste svar mottaget: {0}",
		"LiveView.Work.NoNewerAnswers": "Inga nyare svar har tagits emot",
		"LiveView.Work.NoAnswers": "Inga svar mottagna",
		"LiveView.Work.Started": "Startade: {0}",
		"LiveView.Work.FileReceived": "Svarsfil mottagen: {0}",
		"LiveView.Work.FileReceivedLabel": "Fil mottagen",
		"LiveView.WorkReceived": "Mottaget arbete",
		"LiveView.FirstStarted": "Första start",
		"LiveView.LastAnswerReceived": "Senaste svar mottaget",
		"LiveView.LastHandIn": "Senaste inlämning",
		"LiveView.LockStatus": "Låsstatus",
		"LiveView.Filters.Showing": "Visar {0} av {1} elever",
		"LiveView.Filters.ShowAll": "Visa alla elever",
		"LiveView.Filters.WithRecordedHandIn": "Med registrerad inlämning",
		"LiveView.BulkAccessScope": "Gäller alla elever i provet, även elever som döljs av filter.",
		"LiveView.ExamAccess": "Åtkomst till prov",
		"LiveView.ExamTools": "Provverktyg och inställningar",
		"LiveView.UpdatesExplanation": "Uteblivna uppdateringar kan bero på en stängd app, internetproblem eller att liveuppdateringar saknas. Eleven kan fortfarande arbeta.",
		"LiveView.Monitor.Delayed": "Klassöversikten uppdateras inte",
		"LiveView.Monitor.LastSuccess": "Senaste lyckade uppdatering",
		"LiveView.Monitor.WaitingForFirstUpdate": "Väntar på den första lyckade uppdateringen. Elevstatus är ännu inte tillgänglig.",
		"LiveView.Monitor.DelayedExplanation": "Antal och rader visar senast kända läge. Nya varningar om elevers anslutningar kan inte avgöras förrän uppdateringarna återupptas.",
		"LiveView.Monitor.LoadingFailed": "Klassöversikten kunde inte laddas. Uppdatera för att försöka igen.",
		"LiveView.Monitor.LastKnown": "Senast känt",
		"LiveView.Monitor.Refresh": "Uppdatera nu",
		"LiveView.Sort.Ascending": "A–Ö",
		"LiveView.Sort.Descending": "Ö–A",
		"LiveView.Sort.Reverse": "Vänd sorteringsordningen",
		"LiveView.Sort.Students": "Sortera elever",
		"LiveView.AccessError": "Ändringen kunde inte sparas. Föregående status är oförändrad. Försök igen.",
		"LiveView.End.UnfinishedWarning": "Vissa elever har inte lämnat in sitt aktuella arbete. Återupptaget arbete kräver en ny inlämning.",
		"LiveView.End.ReopenedWarning": "Vissa inlämnade prov är upplåsta så att eleverna kan fortsätta. När provet avslutas kan eleverna inte återvända.",
		"Lockstatus": "Låsstatus",
		"TheClassName": "Klassens namn",
		"Create": "Skapa",
		"EnterTheClassName": "Ange klassens namn",
		"TheNameIsNotAllowed": "Namnet är inte tillåtet.",
		"TheCourseName": "Kursens namn",
		"EnterTheCourseName": "Ange kursens namn",
		"TheGroupsName": "Gruppens namn",
		"EnterTheGroupsName": "Ange gruppens namn",
		"TextQuestion": "Fritextfråga",
		"SingleChoiceQuestion": "Flera val", // Single choice --> Flera val
		"MultiChoiceQuestion": "Flera rätta svar", // Multiple choice --> Flera rätta svar
		"WordGapQuestion": "Ordluckor",
		"LoadDraft": "Ladda utkast",
		"LoadDraftExplanation": "Vi hittade ett utkast med ändringar av \"{0}\" som senast redigerades {1}, vill du ladda utkastet?",
		"NoDiscardDraft": "Nej, kasta utkastet",
		"QuestionCapDescription_Soft": "En mjuk begränsning tillåter eleverna att överskrida gränsen, och en varning visas om den är överskriden.",
		"QuestionCapDescription_Hard": "En hård begränsning hindrar eleverna från att överskrida gränsen.",
		"QuestionTitle": "Frågerubrik",
		"QuestionShownToTheStudents": "Frågan som visas för eleverna",
		"QuestionNeedsAValidAnswer": "Ett av svarsalternativen måste vara markerat som korrekt.",
		"Alternative": "Alternativ",
		"Options": "Alternativ",
		"AddAlternative": "Lägg till alternativ",
		"QuestionNeedsAtLeastAValidAnswer": "Minst ett av svarsalternativen måste vara markerat som korrekt.",
		"Correct": "Rätt",
		"CorrectAnswer": "Korrekt svar",
		"CorrectAlternative": "Korrekt alternativ",
		"IncorrectAnswer": "Fel svar",
		"Scoring": "Poängsättning",
		"RemoveImage": "Ta bort bild",
		"Remove": common.remove,
		"MoveUp": "Flytta upp",
		"MoveDown": "Flytta ner",
		"Exam": "Prov",
		"EndExam": "Avsluta prov",
		"RemoteProctoring": "Fjärrövervakning",
		"RemoteProctoring.Access": "Öppna fjärrövervakning",
		"RemoteProctoring.Info": "Denna knapp öppnar en ny flik till det externa gränssnittet för fjärrövervakning.",
		"DownloadOfflineFile": "Ladda ner offlinefil",
		"NoStudentsStartedTheExam": "Ingen elev har startat det här provet",
		"StudentsHasNotHandedInFinalAnswers": "En eller flera studenter har inte lämnat in sina slutgiltiga svar.",
		"StudentsAreOfflineAndHasNotHadTheirFinalAnswersUploaded": "En eller flera studenter är offline och har inte fått sina slutgiltiga svar uppladdade.",
		"StudentsHasNotStartedTheExam": "En eller flera studenter har inte startat provet.",
		"Done": "Klar",
		"EditCourse": "Redigera kurs",
		"LackingPermissions": "Saknar behörighet",
		"LackingPermissionsToDoThis": "Du saknar behörighet för att göra detta.",
		"Change": common.edit,
		"ArchiveCourse": "Arkivera kurs",
		"AreYouSureYouWantToArchiveTheCourse": "Vill du arkivera kursen?",
		"Archive_Course_YouCanNotUndoThis": "När kursen arkiveras flyttas den till arkivet, du kan återställa den senare.",
		"Upload": common.upload,
		"TheFileIsEmpty": "Filen är tom.",
		"CouldNotReadFile": "Kunde inte läsa en del eller hela filen på grund av felaktigt format.",
		"CouldNotRead": "Kunde inte läsa",
		"TheLine": "raden",
		"TheLines": "raderna",
		"SomethingWentWrong": "Någonting gick snett.",
		"SomethingWentWrongLong": "Ett fel inträffade, var vänlig försök igen lite senare eller kontakta support.",
		"LatestDownload": "Senast nedladdad",
		"NotSet": "Ej satt",
		"NotAnswered": "Ej besvarad",
		"NotGraded": "Ej rättad",
		"Published": "Publicerad",
		"NotPublished": "Ej publicerad",
		"Published.plural": "Publicerade",
		"NotPublished.plural": "Ej publicerade",
		"NotHandedIn": "Ej inlämnad",
		"HandedIn": "Inlämnad",
		"NotHandedIn.plural": "Ej inlämnade",
		"HandedIn.plural": "Inlämnade",
		"CurrentExam": "Nuvarande prov",
		"NotYetRated": "Ej betygsatt",
		"GradesLastSaved": "Rättningen sparades senast:",
		"TheStudent": "Eleven",
		"Student": common.student,
		"StudentX": "Elev {0}",
		"StudentsAnswers": "Elevernas svar",
		"FinalGrade": "Provresultat",
		"FinalGradesForX": "Provresultat för {0}",
		"FinalGradesFor": "Provresultat för",
		"ResultsVisibilityWhenPublishing": "Eleverna kommer kunna se frågorna, svaren, kommentarerna och betygen om du publicerar resultaten.",
		"ResultsVisibilityWhenUnpublishing": "Eleverna kommer inte längre kunna se frågorna, svaren, kommentarerna och betygen om du avpublicerar resultaten.",
		"ThereAreStillStudentsWhoAreUnfinished": "Det finns fortfarande elever vars slutgiltiga svar inte har laddats upp, vill du verkligen publicera resultaten?",
		"Publish.Ellipsis": "Publicera...",
		"Unpublish.Ellipsis": "Avpublicera...",
		"PublishResults": "Publicera resultaten",
		"UnpublishResults": "Avpublicera resultaten",
		"PublishedTheResults": "Publicerade resultaten",
		"UnpublishedTheResults": "Avpublicerade resultaten",
		"FailedToPublishResults": "Misslyckades att publicera resultaten",
		"FailedToUnpublishResults": "Misslyckades att avpublicera resultaten",
		"ResultsForX": "Resultat för {0}",
		"WordsNoCap": "ord, ingen begränsning",
		"WordsSoftCap": "ord, mjuk begränsning",
		"WordsHardCap": "ord, hård begränsning",
		"Grading": "Rättning",
		"SearchStudent": "Sök elev",
		"FinalGradesForXHasNotBeenTurnedIn": "Slutgiltiga provsvaren för {0} har inte lämnats in och därför kan elevens prov inte betygsättas.",
		"UploadOffLineFileToGradeStudent": "Ladda upp en offline fil med elevens slutgiltiga svar för att kunna betygsätta eleven.",
		"OfflineFileName": "Offlinefilen borde heta: {0}",
		"Answer": "svar",
		"Answer.Capitalized": "Svar",
		"Answer.WordCount": "Antal ord",
		"XAnswer": "{0} svar",
		"point": "poäng",
		"points": "poäng",
		"XPoints": "{0} poäng",
		"XOfYPoints": "{0} av {1} poäng",
		"Points": "Poäng",
		"Total": "Totalt",
		"Grade": "Nivå",
		"Grades": "Nivåer",
		"Grade.Verb": "Rätta",
		"Ability": "Förmåga",
		"Abilities": "Förmågor",
		"StartGrade": "Börja rätta",
		"ToOverview": "Till översikten",
		"XOfYQuestionsGraded": "{0} av {1} frågor rättade",
		"Of": "av",
		"XOfY": "{0} av {1}",
		"AnswerShouldBeAroundXWordsLong": "Svaret ska vara ungefär {0} ord långt",
		"AnswerMayNotBeLongerThanXWords": "Svaret får inte vara längre än {0} ord",
		"OnlyOneAlternativeIsCorrect": "Endast ett alternativ är rätt",
		"ManyAlternativesAreCorrect": "Flera alternativ kan vara rätt",
		"PrintExam": "Skriv ut prov",
		"Teacher": "Lärare",
		"Scope_make_course": "Skapa kurs",
		"Scope_view_course": "Visa kurs",
		"Scope_edit_course": "Redigera kurs",
		"Scope_make_exam": "Skapa prov",
		"Scope_view_exam": "Visa prov",
		"Scope_edit_exam": "Redigera prov",
		"Scope_plan_exam": "Planera prov",
		"Scope_stop_exam": "Stoppa prov",
		"Scope_copy_exam": "Kopiera prov",
		"Scope_open_exam": "Öppna prov",
		"Scope_run_exam": "Kör prov",
		"Scope_grade_exam": "Rätta prov",
		"Scope_view_exam_grades": "View exam grades",
		"Scope_download_exam": "Ladda ner prov",
		"Scope_upload_exam": "Ladda upp prov",
		"Scope_monitor_exam": "Monitor exam",
		"Scope_publish_exam": "Publicera prov",
		"Scope_link_class": "Länka klass",
		"Scope_make_group": "Skapa grupp",
		"Scope_link_group": "Länka grupp",
		"Scope_view_group": "Visa grupp",
		"Scope_edit_group": "Redigera grupp",
		"Scope_archive_group": "Arkivera grupp",
		"Scope_pull_student": "Pull elev",
		"Scope_add_student": "Lägga till elev",
		"Scope_make_node": "Skapa nod",
		"Scope_apply_role": "Tillämpa roll",
		"Scope_make_role": "Skapa roll",
		"StartDate": "Startdatum",
		"StartTimeLocal": "Starttid (lokal tid)",
		"LimitDescription": "Antal minuter efter start provet kan öppnas",
		"Stop": "Stopp",
		"StopDate": "Stoppdatum",
		"StopTime": "Stopptid",
		"DurationDescription": "Antal minuter som eleven har på sig att skriva provet",
		"OtherSettings": "Övriga inställningar",
		"MaximumScore": "Max antal poäng för det här provet",
		"AreYouReallySure": "Är du säker?",
		"Elapsed": "Passerat",
		"OverallProgress": "Sammanställning",
		"Print.PageBreak": "Sidbrytning",
		"Print.BlankPage": "Blank Sida",
		"Print": "Skriv ut",
		"PrintAttendance": "Skriv ut närvarolista",
		"PrintPaperExam": "Skriv ut prov",
		"Print.Ellipsis": "Skriv ut eller ladda ner...",
		"DownloadPDF.One": "Ladda ned som en PDF-fil",
		"DownloadPDF.Multiple": "Ladda ned som enskilda PDF-filer",
		"PrintResults": "Skriv ut resultaten",
		"PrintResults.Feedback.Error.NoStudentSelected": "Du måste markera minst en elev vars svar skrivs ut.",
		"PrintResults.Feedback.Error.NoQuestionSelected": "Du måste markera minst en fråga att skriva ut.",
		"PrintCloud.Button": "Moln Print",
		"PrintCloud.Header": " Digiexam Moln Print",
		"PrintCloud.Body": "Du är på väg att skriva ut med Digiexam Moln print. Mejlen kommer att skickas till {0} inom 20 minuter.",
		"PrintCloud.FileSelect": "Ladda ner som en fil eller flera filer",
		"PrintCloud.FileSelect.SingleFile": "En fil",
		"PrintCloud.FileSelect.MultipleFiles": "Flera filer",
		"Share": "Dela",
		"ShareGradingWork": "Dela rättningsarbetet",
		"ShareGradingWork.Ellipsis": "Dela rättningsarbetet...",
		"ShareGradingWork.Remove": "Ta bort rättningsdelning",
		"ThisUserIsDeleted": "Användare borttagen",
		"XOfYFinalResultsSet": "{0} av {1} provresultat satta",
		"Loading": "Laddar",
		"LoadingExam": "Laddar prov",
		"ContinueGrading": "Fortsätt rätta",
		"HideGradedStudents": "Göm rättade elever",
		"ShowGradedStudents": "Visa rättade elever",
		"NextStudent": "Nästa elev",
		"PreviousStudent": "Föregående elev",
		"CantEditGradeBecausePublished": "Du kan inte redigera en elevs resultat när provet är publicerad. Var god avpublicera provet först.",
		"XHasNotAnsweredThisQuestion": "{0} har inte svarat på den här frågan.",
		"StudentHasNoFinalGrade": "Ej betygsatt",
		"XHasLeftExamBlankYouCantAnswer": "{0} har blankat sitt prov, du kan inte betygsätta ett blankat prov.",
		"TypeToSearch": "Skriv i fältet ovanför för att söka...",
		"NoStudentsFound": "Hittade inga elever.",
		"RemoveTheActiveFiltersToShowHiddenStudents": "Ta bort dom aktiva filtrena för att visa dolda elever.",
		"RemoveFilters": "Ta bort filter",
		"All": "Alla",
		"Online": "Online",
		"PenAndPaper": "Papper & penna",
		"Offline": "Offline",
		"Absent": "Frånvarande",
		"Active": "Aktiva",
		"YesStartExam": "Ja, starta provet",
		"DoYouWantToStartTheExam": "Vill du starta provet {0}",
		"ExamId": "Prov ID",
		"Ongoing": "Pågående",
		"NotStarted": "Ej startad",
		"MoveExam": "Flytta prov",
		"ErrorLoadingCourses": "Ett fel uppstod när kurserna hämtades",
		"FaultMovingExamTryAgainLater": "Ett fel inträffade vid flytten av provet, var vänlig försök igen lite senare eller kontakta support.",
		"ChooseWhichClassToMoveExam": "Välj vilken klass du vill flytta provet till.",
		"YouNeedToSetATitle": "Du behöver sätta en titel.",
		"YouNeedToSetASubject": "Du behöver sätta ett ämne",
		"ThereIsAlreadyARubricWithThatTitle": "Det finns redan en bedömningsmatris med den titeln.",
		"YouNeedToAddQuestions": "Du behöver lägga till frågor.",
		"AQuestionNeedsATitle": "En fråga behöver en titel.",
		"AQuestionNeedsText": "En fråga behöver en text.",
		"AMOrSQuestionNeedsAlternatives": "En fler- eller enkelvalsfråga behöver alternativ.",
		"AQuestionAlternativeNeedsATitle": "Ett frågealternativ behöver en titel.",
		"AMOrSQuestionNeedsCorrectAlternative": "En fler- eller enkelvalsfråga behöver ett korrekt alternativ.",
		"AQuestionHasAnInvalidCap": "En fråga har en inkorrekt ordbegränsning.",
		"AQuestionNeedsAMaxScore": "En fråga behöver max poäng.",
		"Search": "Sök",
		"QuestionNotGraded": "Frågan är ej rättad.",
		"TeachersComment": "Lärarens kommentar",
		"ObtainedScore": "Erhållen poäng",
		"TextOnlyQuestion": "Rubrik",
		"TextOnlyAboutPlaceholder": "Rubrikbeskrivning (frivillig)",
		"Abbreviation": "Förkortning",
		"UpdateInformation": "Uppdatera information",
		"ChangeCover": "Byt omslag",
		"ChangeProfilePhotoOrCover": "Bilder för organisationen",
		"Incorrect": "Fel",
		"NotUploaded": "Ej uppladdad",
		"Uploaded": "Uppladdad",
		"Uploading": "Laddar upp",
		"UploadFailed": "Fel vid uppladdning",
		"DoYouWantToShareX": "Vill du dela '%v'?",
		"EnterTheEmailAdressYouWantToShareWith": "Skriv in e-postadressen till personen du vill dela '%v' med",
		"ExampleEmail": "exempel@exempel.se",
		"Organization": "Organisation",
		"Organization.Edit": "Redigera {0}",
		"AllOrganizations": "Alla organisationer",
		"AllOrganizationTypes": "Alla organisationstyper",
		"UnspecifiedQualityStatus": "Ospecificerad kvalitetsstatus",
		"Created": "Skapad",
		"Freemium": "Freemium",
		"NonFreemium": "Ej freemium",
		"FeatureRemoteProctoringEnabled": "Funktion: Fjärrövervakning",
		"LoggingYouIn": "Loggar in dig",
		"LoggingIn": "Loggar in",
		"Statistics": "Statistik",
		"Roles": "Roller",
		"RolesAndUsers": "Roller & användare",
		"Permissions": "Rättigheter",
		"NumberOfUsers": "Antal användare",
		"NoRolesAddedAddRole": "Inga roller tillagda. Lägg till en roll.",
		"AddRole": "Lägg till roll",
		"PendingInvites": "Väntande inbjudningar",
		"NoPendingInvites": "Inga väntande inbjudningar.",
		"InviteUsers": "Bjud in användare",
		"Revoke": "Återkalla",
		"ALinkWillBeSentToThisUserInvite": "En länk kommer att bli skickad till dessa användare där kan de godkänna inbjudningen. Om de godkänner inbjudningen kan de välja att använda ett befintligt konto eller skapa ett nytt.",
		"Role": "Roll",
		"ToInvite": "Bjud in",
		"TheRoleXHasBeenCreated": "Rollen '{0}' har blivit skapad.",
		"TheRoleXHasBeenDeleted": "Rollen '{0}' har blivit borttagen.",
		"TheNodeYouTriedToVisitDoesntExist": "Organisationen du försökte besöka finns inte.",
		"Teachers": "Lärare",
		"Exams": common.exams,
		"ExamTemplates": common.examTemplates,
		"TheInviteToXHasBeenSent": "Inbjudningen till '{0}' har blivit skickad.",
		"TheInvitesToXPeopleBeenSent": "Inbjudningarna till {0} personer har blivit skickad.",
		"FailedToSendInvite": "Misslyckades att skicka inbjudningen: {0}",
		"FailedToSendInvites": "Misslyckades att skicka inbjudningarna: {0}",
		"YouNowHaveTheRoleOfXAtX": "Du innehar nu rollen som {0} hos {1}.",
		"InvalidInviteError": "Inbjudan du försökt nå är inte giltig.",
		"InvalidActivationLinkError": "Aktiveringslänken som du försökt använda är ogiltig.",
		"Resend": "Skicka igen",
		"UsersWithRole": "Användare med rollen",
		"ChangeProfileImage": "Byt profilbild",
		"UploadImage.FailedX": "Misslyckades att ladda upp bild: {0}",
		"EditInformation": "Redigera information",
		"DoYouWantToRemoveTheRole": "Vill du ta bort rollen?",
		"DoYouWantToRemoveTheRoleX": "Vill du ta bort rollen {0}",
		"DoYouWantToRevokeTheRole": "Vill du återkalla rollen?",
		"DoYouWantToRevokeTheRoleForX": "Vill du återkalla rollen för {0}?",
		"RevokedRoleXFromX": "Återkallade rollen {0} från {1}",
		"CouldNotRevokeRoleXFromX": "Kunde inte återkalla rollen {0} för {1}.",
		"RoleIsExternallyManaged": "Rollen hanteras externt och kommer endast att återkallas i Digiexam och inte i huvudsystemet.",
		"ResentTheInviteToX": "Skickade inbjudan till {0} igen.",
		"CouldNotResendTheInviteToX": "Kunde inte skicka inbjudan till {0} igen.",
		"DoYouWantToRemoveTheInvite": "Vill du ta bort inbjudan?",
		"DoYouWantToRemoveTheInviteToX": "Vill du ta bort inbjudan till {0}?",
		"RemovedTheInviteToX": "Tog bort inbjudan till {0}.",
		"CouldNotRemoveTheInviteToX": "Kunde inte ta bort inbjudan till {0}.",
		"TheOrganizationXHasBeenCreated": "Organisationen {0} har skapats.",
		"Organizations": "Organisationer",
		"CreateOrganization": "Skapa organisation",
		"ParentOrganizationId": "Förälderorganisation ID",
		"CouldNotCreateTheOrganizationX": "Kunde inte skapa organizationen {0}.",
		"CouldNotRemoveExamX": "Kunde inte ta bort provet \"{0}\".",
		"RemovedExamX": "Tog bort provet \"{0}\".",
		"AnonymizeExam": "Anonymisera provet",
		"AnonymizeExam.Ellipsis": "Anonymisera provet...",
		"DeAnonymize": "Ta bort anonymiseringen",
		"DeAnonymize.Ellipsis": "Ta bort anonymiseringen...",
		"AnonymizeExplanation": "Ändrar du provet till att vara anonymt så döljs elevernas/studenternas namn och övrig information för de som rättar, skriver ut provet eller laddar ner dess kalkylblad.",
		"DeAnonymizeExplanation": "Tar du bort anonymiseringen av provet så syns elevernas/studenternas namn och övrig information för de som rättar, skriver ut provet/tentan eller laddar ner dess kalkyblad.",
		"RoleType_0": "PUB",
		"RoleType_1": common.student,
		"RoleType_2": "Lärare",
		"RoleType_4": "Administratör",
		"RoleType_8": "Master",
		"RoleType_16": "Kontohanterare",
		"RoleType_32": "Provövervakare",
		"ShareTheResults": "Dela resultaten",
		"YouSharedXWithY": "Du delade \"{0}\" med {1}",
		"CouldNotShareCantHandleExams": "Kunde inte dela provet, användaren kan inte hantera prov.",
		"CouldNotShareCantHandleRubrics": "Kunde inte dela matrisen, användaren kan inte hantera matriser.",
		"CouldNotShareExamNoEmailX": "Kunde inte dela provet för det finns ingen användare med e-postadressen \"{0}\"",
		"CouldNotShareExamCantGrade": "Kunde inte dela provet för att  \"{0}\" inte kan rätta prov",
		"CouldNotShareGradingOwner": "Kunde inte dela rättningen för att  \"{0}\" är ägaren av detta prov",
		"FailedToShareExam": "Misslyckades att dela provet",
		"FailedToShareRubric": "Misslyckades att dela matrisen",
		"NameOrStudentCode": "Namn eller studentkod",
		"Previous": "Förgående",
		"Next": "Nästa",
		"NoExamsFound": "Inga prov hittades",
		"ShowQuestionDetails": "Visa frågans innehåll",
		"HideQuestionDetails": "Dölj frågans innehåll",
		"Images": "Bilder",
		"Image": "Bild",
		"ColorRed": "Röd",
		"ColorBlue": "Blå",
		"ColorAqua": "Aqua",
		"ColorPink": "Rosa",
		"ColorGreen": "Grön",
		"ColorYellow": "Gul",
		"Color": "Färg",
		"Comment": "Kommentar",
		"AnnotationSummary": "Sammanfattning av annoteringar",
		"TeachersAnnotations": "Lärarens annoteringar",
		"TeachersAnnotations.Tooltip.Text": "Bakgrundsgrafik används i utskriftsinställningarna för att visa annoteringsfärgen.",
		"Delete": "Radera",
		"Deleted": "Raderade",
		"OnePerLine": "En per rad",
		"UserIsDisabled": "Användaren är avstängd",
		"ContactDigiExamForMoreInformation": "Kontakta Digiexam för mer information.",
		"ServerRespondedWith": "Servern svarade med: {0}",
		"ShowMore": "Visa mer",
		"ShowLess": "Visa mindre",
		"MustBeANumber": "Måste vara ett nummer",
		"CantBeHigherThanX": "Får inte vara högre än {0}",
		"CantBeLowerThanX": "Får inte vara lägre än {0}",
		"Rubric": "Bedömningsmatris",
		"Rubrics": common.rubrics,
		"RemoveGrade": "Ta bort nivå",
		"RemoveAbility": "Ta bort förmåga",
		"WarningWhenRemovingRubricGrade": "Tar du bort denna nivån tas även alla kriterier som är förknippade med nivån bort.",
		"WarningWhenRemovingRubricAbility": "Tar du bort denna förmågan tas även alla kriterier som är förknippade med förmågan bort.",
		"AddGrade": "Lägg till nivå",
		"AddAbility": "Lägg till förmåga",
		"ClickToEdit": "Klicka för att ändra",
		"Criteria": "Kriterier",
		"Criterion": "Kriterium",
		"Description": "Beskrivning",
		"AssessmentType": "Bedömningstyp",
		"ScoreBasedGrading": "Poängbaserad rättning",
		"ScoreBasedGrading.Description": "Provet är poängbaserat.",
		"ScoreBasedGrading.Info1": "Använd poäng för att rätta frågor och sätt ett slutgiltigt betyg på provet. Frågor med flera val och flera rätta svar rättas automatiskt åt dig.",
		"RubricBasedAssessment": "Bedömningsmatris",
		"RubricBasedAssessment.Description": "Provet bedöms utifrån en bedömningsmatris.",
		"RubricBasedAssessment.Info1": "Koppla en bedömningsmatris till provet för att mer detaljerat kunna bedöma hur studenter presterar i olika förmågor.",
		"DropARubricHereToUseItInTheExam": "Släpp en bedömningsmatris här för att använda den i provet.",
		"View": "Visa",
		"RubricRequiredToSelectQuestionAbilities": "Du behöver lägga till en bedömningsmatris i det här provet innan du kan välja förmågor för denna frågan.",
		"AbilitiesToMeasure": "Förmågor att mäta",
		"AnsweringAlternatives": "Svarsalternativ",
		"RemovingRubricFromExamWarning": "Några frågor i provet är konfigurerade med förmågor att mäta. Om du tar bort bedömningsmatrisen så kommer även den konfigurationen att tas bort. Är du säker på att du vill ta bort bedömningsmatrisen \"{0}\"?",
		"GradeNameIsRequired": "Namn på nivån behövs",
		"AbilityNameIsRequired": "Namn på förmågan behövs",
		"NamelessGrade": "Namnlös nivå",
		"YouNeedToAddGrades": "Du behöver lägga till nivåer",
		"YouNeedToAddAbilities": "Du behöver lägga till förmågor",
		"ResultSummary": "Resultatsammanfattning",
		"SummarizedAssessment": "Summerad bedömning",
		"ShowRubric": "Visa bedömningsmatrisen",
		"PublishedResults": "Publicerade resultat",
		"TheResultsArePublished": "Resultaten är publicerade",
		"ShowWhichPartsCanBeSeenByTheStudents": "Visa vilka delar som eleverna kan se",
		"StudentsResults": "Elevernas resultat",
		"ShowIfAlternativeIsCorrect": "Visa om alternativ är rätt",
		"Score": "Poäng",
		"RightToLeft.Long": "Textriktning: Höger till vänster",
		"RightToLeft.Long.Info1": "Använd den här inställningen för skriftspråk som skrivs höger till vänster, t. ex. persiska, arabiska och hebreiska.",
		"LockedQuestionSequence.Title": "Låst frågeordning (MEQ)",
		"LockedQuestionSequence.Disclaimer": "Frågerubrikerna kommer fortfarande vara synliga.",
		"LockedQuestionSequence.Info": "Ordningen på frågorna är låst i provet. En student kan inte gå tillbaka till en besvarad fråga för att redigera sitt svar.",
		"FindStudents": "Hitta elever",
		"StudentName": "Elevnamn",
		"StudentSearch.Placeholder": "Namn, studentkod eller e-postadress",
		"StudentSearch.Placeholder.CodeDisabled": "Namn eller e-postadress",
		"StudentSearch.TooManyResults": "Prova en längre sökterm för att reducera antalet resultat",
		"StudentSearch.Unauthorized": "Freemium-skolor är inte tillåtna att hantera elever. Kontakta sälj för att uppgradera skolan.",
		"StudentSearch.FilterTooltip": "Du kan filtrera resultatet baserat på de tillgänglighetsinställningar som är aktiverade för eleven. Flytta muspekaren till \"Tillgänglighetsinställningar\" och välj de inställningar som skall användas för filtrering.",
		"StudentSearch.ShowAll": "Visa alla",
		"StudentSearch.ShowAllByEmailCode": "Visa alla (med e-postadress som studentkod)",
		"StudentSearchUnavailable": "Kan inte söka efter elever för tillfället, vänligen försök igen eller kontakta Digiexams support.",
		"AccountCreated": "Konto skapat",
		"StudentAt": "Student vid",
		"NoClassesFound": "Inga klasser hittades",
		"ViewResult": "Visa resultat",
		"ViewClass": "Visa klass",
		"StudentHasNotParticipatedInAnyExams": "Eleven har inte deltagit i något prov som du har tillgång till.",
		"StudentDoesNotBelongToAnyClass": "Eleven tillhör ingen klass som du har tillgång till.",
		"StudentNotFound": "Kunde ej hitta en elev med id {0}",
		"Exam.OnlyYourExamsShown": "Endast dina egna prov visas.",
		"Class.OnlyYourClassesShown": "Endast dina egna klasser visas.",
		"RubricUsedInExam": "Denna bedömningsmatris har använts till ett prov. Nivåer och förmågor kan inte längre ändras.",
		"SaveAsNewCopyRubric": "Välj SPARA SOM NY för att skapa en ny kopia av denna bedömningsmatris.",
		"SetANewTitle": "Välj en ny titel.",
		"Fullscreen": "Helskärm",
		"ExitFullscreen": "Gå ur helskärm",
		"SalesCRMId": "Pipedrive ID",
		"Search.ShowingXofYMatches": "Visar {0} av {1} träffar",
		"TeachersFeedback": "Lärarens återkoppling",
		"TeachersFeedback.Long": "Lärarens återkoppling till eleven",
		"TeachersFinalFeedback.Long": "Lärarens slutgiltiga återkoppling till eleven",
		"Publish.Publish.LongTitle": "Publicera resultaten så eleverna kan se dem",
		"Publish.Publish.PartDescription": "Markera de delarna som ska synas för eleverna.",
		"Publish.Published.LongTitle": "Publicerade resultat som eleverna kan se",
		"Publish.Published.PartDescription.ExamOwnerOrAdmin": "De markerade delarna är synliga för eleverna, du kan ändra vilka delar som eleverna kan se.",
		"Publish.Published.PartDescription.NotExamOwnerOrAdmin": "De markerade delarna är synliga för eleverna. Endast ägaren av provet kan ändra vilka delar som eleverna kan se.",
		"Publish.Unpublish.LongTitle": "Avpublicera resultaten för eleverna",
		"Publish.Unpublish.PartDescription": "De markerade delarna är synliga för eleverna.",
		"Publish.StudentDescription": "Eleverna kan endast se sina egna svar.",
		"ShareGrading.LongTitle": "Dela rättningsarbetet med en annan lärare",
		"ShareGrading.Description": "Markera de frågor och elever som du vill att läraren ska få rätta.",
		"ShareGrading.EmailLabel": "E-postadressen till läraren du vill dela med",
		"ShareGrading.Error.EmailMissing": "Du måste ange e-postadressen till läraren som du vill dela rättningsarbetet med.",
		"ShareGrading.Error.NoQuestionsSelected": "Du måste markera minst en fråga att dela.",
		"ShareGrading.Error.NoStudentSelected": "Du måste markera minst en elev att dela.",
		"Student.StudentCode.Notification.AlreadyAdded.Class": "Studentkoden redan i klassen",
		"Student.StudentCode.Error.MinLength": "Studentkoden måste vara minst 1 tecken långt",
		"Student.StudentCode.Error.MaxLength": "Studentkoden får inte vara mer än 50 tecken långt",
		"Student.StudentCode.Error.Chars": "Studentkoden får endast innehålla följande tecken: a-Z 0-9 - . @ _",
		"Student.Name.Error.MinLength": "Namnet måste vara minst 2 tecken långt",
		"Student.Name.Error.MaxLength": "Namnet får max vara 500 tecken långt",
		"Student.New": "Ny elev",
		"Student.ChangeStudentCode.Title": "Ändra Studentkod",
		"Student.ChangeStudentCode.Description": "Detta verktyg används för att ändra många studentkoder samtidigt.",
		"Student.ChangeStudentCode.Excel": "Klistra in från excel i formatet: e-postadress, studentkod",
		"Student.ChangeStudentCode.WontApply": "Ändringar i studentkoden som inte kommer att tillämpas",
		"Student.ChangeStudentCode.WillApply": "Ändringar i studentkoden som ska tillämpas",
		"Student.ChangeStudentCode.Perform": "Genomför ändring av koder",
		"Student.ChangeStudentCode.Verify": "Verifiera ändring av koder",
		"Student.ChangeStudentCode.TooManySelected": "Det går inte att ändra koden för fler än {0} elever samtidigt.",
		"Student.ChangeStudentCode.Success.Single": "Elevens kod har ändrats.",
		"Student.ChangeStudentCode.Success": "{0} elevs koder har ändrats",
		"Student.ChangeStudentCode.Progress": "Ändra kod för {0} elever",
		"Student.ChangeStudentCode.Failure": "Följande elever kunde inte ändras:",
		"Student.Delete": "Ta bort elever",
		"Student.Notification.AlreadyAdded.Class": "{0} finns redan i klassen",
		"Student.Notification.Error": "Ett fel uppstod, {0} kunde ej läggas till",
		"Student.Notification.DoesNotExist.Single": "Ingen elev med e-posten {0} existerar på organisationen",
		"Student.Notification.DoesNotExist.Multiple": "Eleven existerar inte på organisationen",
		"Student.Notification.NotAdded": "Elev ej tillagd",
		"Student.Delete.Progress": "Tar bort {0} elever",
		"Student.Delete.Explanation": "Endast elever som inte startat och inte är ansluta till prov kan tas bort.",
		"Student.Delete.Others": "och {0} andra...",
		"Student.Delete.Success.Single": "Eleven togs bort",
		"Student.Delete.Success": "{0} elever togs bort",
		"Student.Delete.Failure": "Följande elever kunde inte tas bort:",
		"Student.Delete.Button": "Ta bort {0} elever",
		"Student.Delete.Button.Single": "Ta bort {0} elev",
		"Student.Delete.TooManySelected": "Det går ej att ta bort fler än {0} elever samtidigt",
		"Feedback.Saving.Ellipsis": "Sparar...",
		"Feedback.Saved": "Sparat",
		"Feedback.Saved.1:Time": "Sparat {0}",
		"Feedback.AutoSaved.1:Time": "Automatiskt sparat {0}",
		"Feedback.DraftSaved": "Utkast sparat",
		"Feedback.DraftSaved.1:Time": "Utkast sparat {0}",
		"Feedback.ErrorSaving": "Lyckades inte spara",
		"Feedback.FailedToShareExam": "Misslyckades med att dela prov",
		"Feedback.CouldNotRemoveShare": "Kunde inte ta bort delning",
		"Feedback.Added.Entity": "{0} har blivit tillagd till klassen",
		"Feedback.Added.Single.Student": "Lade till 1 elev",
		"Feedback.Added.Count.Students": "Lade till {0} elever",
		"Feedback.ErrorArchiving": "Arkivering misslyckades",
		"Feedback.ErrorDeleting": "Radering misslyckades",
		"Feedback.SuccessArchived": "Arkiverad!",
		"Feedback.SuccessDeleted": "Raderad!",
		"Entity.Created.By": "av {0}",
		"Shared.By": "Delat av {0}",
		"Exam.State.0": "Tom",
		"Exam.State.1": "Utkast",
		"Exam.State.2": "Inlämnad",
		"Exam.State.3": "Blankad",
		"Exam.Parts": "Delar",
		"Action.Continue": "Fortsätt",
		"Action.Restore": "Återställ",
		"Action.Delete": "Radera",
		"Action.DeleteSelected": "Radera markerade",
		"Action.SelectAll": "Markera alla",
		"Action.DeselectAll": "Avmarkera alla",
		"Action.AddStudent": "Lägg till elev",
		"Action.AddStudentToClass": "Lägg till elev till klass",
		"Action.AddStudentWithEmail": "Lägg till elev med e-postadress",
		"Action.AddStudent.Plural": "Lägg till många elever",
		"Action.SelectRubric": "Välj bedömningsmatris",
		"Action.CannotBeUndone": "Denna handling kan ej återställas",
		"State.Deleted": "Borttagen",
		"State.Archived": "Arkiverad",
		"State.TeachersFeedback.Missing": "Läraren har inte givit någon återkoppling",
		"State.FinalGrade.Missing": "Läraren har inte satt något provresultat",
		"ForgotPassword.Fail.EmailNotFound": "Det gick inte att hitta något konto med den e-postadressen.",
		"ForgotPassword.Fail.InvalidToken": "Det uppstod ett fel med länken",
		"ForgotPassword.Fail.ExpiredToken": "Denna länk är för gammal",
		"ForgotPassword.Fail.LinkUsed": "Denna länk är redan använd",
		"ForgotPassword.Fail.SendNewLink": "Tryck på knappen för att skicka en ny länk.",
		"ForgotPassword.Fail.SendNewLinkButton": "Skicka ny länk",
		"AcceptInvite.RoleDescription": "Du har blivit inbjuden till rollen som {0} på {1}.",
		"AcceptInvite.HowToAccept.Part1": "Skapa ett konto för att acceptera din inbjudan.",
		"AcceptInvite.HowToAccept.Part2": " om du redan har ett Digiexam-konto.",
		"AcceptInvite.AcceptDescription": "Acceptera rollen som {0} på {1}.",
		"AcceptInvite.InvalidInvite": "Vi kunde inte öppna din inbjudan. Vänligen försök igen eller kontakta personen som skickade den till dig.",
		"PasteFrom.InvalidEmail": "E-postadressen på rad {0} är inte giltig: {1}",
		"PasteFrom.Duplicate": "E-posten på rad {0} är en dublett: {1}, bara ett exemplar av en e-post får finnas i listan.",
		"PasteFrom.DoesNotExist": "Kunde ej lägga till elever, en eller flera elever existerar inte på organisationen",
		"PasteFrom.InvalidColumnCount.SingularExpected": "Rad {0} ska ha {1} kolumn, men den har {2}: {3}",
		"PasteFrom.InvalidColumnCount.PluralExpected": "Rad {0} ska ha {1} kolumner, men den har {2}: {3}",
		"PasteFrom.SomethingWentWrong": "Ett fel inträffade, var vänlig försök igen lite senare eller kontakta support.",
		"AddStudentsToClass": "Lägg till elever till klass",
		"PasteFromSpreadsheet.Title": "Klistra in från kalkylark",
		"PasteFromSpreadsheet.Description": "Du kan lägga till flera elever på samma gång genom att kopiera och klistra in från kalkylark.",
		"PasteFromSpreadsheet.FormatDescription": "Kalkylarket skall innehålla en kolumn med elevens e-post",
		"PasteFromSpreadsheet.ForMoreInformation": "För mer instruktioner, se hjälpartikeln:",
		"PasteFromSpreadsheet.HelpLink.Title": "Lägga till elever i klasser",
		"PasteFromSpreadsheet.HelpLink.Url": "https://digiexam.zendesk.com/hc/sv/articles/202559711",
		"GettingStartedGuide.DoNotShowAgain": "Visa inte den här guiden igen",
		"GettingStartedGuide.CreateYourExam": "Skapa ditt första prov",
		"GettingStartedGuide.slide1.Heading": "Välkommen",
		"MonitorExam.Note": "OBS: Du kan bara bedöma elevsvar som är markerade som ”Inlämnad” i övervakningsvyn. Pågående elevarbete kan fortfarande ändras, och eventuell återkoppling du lämnar skrivs över tills eleven har lämnat in sina svar eller provet är avslutat.",
		"GettingStartedGuide.slide1.Text1": "Introduktion till Digiexam i några enkla steg",
		"GettingStartedGuide.slide1.Text2": "Starta",
		"GettingStartedGuide.slide2.Heading": "Skapa prov",
		"GettingStartedGuide.slide2.Text1": "För att skapa ett prov behöver du en titel, ett ämne och minst en fråga. Du kan skapa prov precis som du vill ha dem. Några av möjligheterna är:",
		"GettingStartedGuide.slide2.Item1": "Poängbaserad bedömning eller bedömningsmatris",
		"GettingStartedGuide.slide2.Item2": "Tillåt stavningskontroll",
		"GettingStartedGuide.slide2.Item3": "Anonymisera prov",
		"GettingStartedGuide.slide3.Heading": "Starta eller schemalägg",
		"GettingStartedGuide.slide3.Text1": "Du kan starta ett prov direkt eller schemalägga det till senare.",
		"GettingStartedGuide.slide4.Heading": "Prov-ID eller grupp",
		"GettingStartedGuide.slide4.Text1": "Du har två alternativ för att ge elever tillgång till provet:",
		"GettingStartedGuide.slide4.Text2": "Prov-ID",
		"GettingStartedGuide.slide4.Text3": "Grupp",
		"GettingStartedGuide.slide4.Item1": "Ett unikt prov-ID genereras när du startar ett prov",
		"GettingStartedGuide.slide4.Item2": "Alla elever som har detta prov-ID kan starta provet",
		"GettingStartedGuide.slide4.Item3": "Du behöver inte lägga till elever i förväg",
		"GettingStartedGuide.slide4.Item4": "Endast elever i den valda listan kan skriva provet",
		"GettingStartedGuide.slide4.Item5": "Kopiera och klistra in elevlistor från Excel",
		"GettingStartedGuide.slide4.Item6": "Provet blir automatiskt tillgängligt för eleverna i listan",
		"GettingStartedGuide.slide5.Heading": "Skriva prov",
		"GettingStartedGuide.slide5.Text1": "Nu är det dags för eleverna att skriva provet! Först behöver de ladda ner Digiexam-appen till sin Windows, Mac, Chromebook eller iPad enhet.",
		"GettingStartedGuide.slide5.Text2": "Elever kommer åt provet genom att ange Prov ID (öppna prov) eller genom att använda samma elevuppgifter som lades till i klassen (planerade prov).",
		"GettingStartedGuide.slide5.tip": "När elever startar provet låser Digiexam-appen deras skärm så att de inte kan göra något annat medan de skriver provet.",
		"GettingStartedGuide.slide6.Heading": "Rätta prov",
		"GettingStartedGuide.slide6.Text1": "Du kan ge elever detaljerad återkoppling på deras svar. Det är enkelt att kommentera och markera delar av elevens svar.",
		"GettingStartedGuide.slide6.Item1": "Rätta provet per fråga eller per elev",
		"GettingStartedGuide.slide6.Item2": "Automatisk rättning av poängbaserade frågor med flera val",
		"GettingStartedGuide.slide6.Item3": "Ingen mer svårförståelig handstil",
		"GettingStartedGuide.slide6.tip": "Du kan dela betygsättningsarbetet med dina kollegor. Det har aldrig varit enklare att rätta och bedöma tillsammans.",
		"GettingStartedGuide.slide7.Heading": "Publicera prov",
		"GettingStartedGuide.slide7.Text1": "När du är färdig med rättningen är du redo att publicera resultaten så att dina elever kan logga in och se sina resultat.",
		"GettingStartedGuide.slide7.Text2": "Du kan välja vilka delar av provet som ska publiceras. Till exempel kan du välja att publicera slutbetyg men inte frågor och svar förrän alla elever har gjort provet.",
		"GettingStartedGuide.slide7.tip": "Det går alltid ändra vad som ska visas i publiceringen, även efter att provet publicerats.",
		"NodeType.Title": "Organisationstyp",
		"NodeType.0": "Ej specifierat",
		"NodeType.1": "Intern",
		"NodeType.2": "Högre utbildning",
		"NodeType.3": "Gymnasium",
		"NodeType.4": "Grundskola",
		"NodeType.5": "Utbildningsföretag",
		"QualityStatus.Title": "Kvalitetsstatus",
		"QualityStatus.0": "Ej verifierad",
		"QualityStatus.1": "Verifierad",
		"QualityStatus.2": "Skräp",
		"AbilityOverview.Title": "Förmågor",
		"AbilityOverview.Description": "Välj en bedömningsmatris för att se hur eleven har presterat i förmågorna som den mäter.",
		"AbilityOverview.NoItems": "För att kunna se elevens prestation i enskilda förmågor måste eleven ha skrivit minst ett prov som har rättats med en bedömingsmatris.",
		"Student.None": "Inga elever",
		"Student.Singular": common.student,
		"Student.Plural": common.students,
		"SyncToLMS.Title": "Läroplattform (LMS)",
		"SyncToLMS.Published": "Skicka dina elevers publicerade betyg och feedback till din läroplattform (Learning Management System, LMS).",
		"Notifications.Title": "Notifieringar",
		"Notifications.Published": "Meddela studenter via e-post att resultat har publicerats.",
		"ExamStarts": "Provet startar",
		"ExamEnded": "Provet avslutades",
		"Month.1": "Januari",
		"Month.2": "Februari",
		"Month.3": "Mars",
		"Month.4": "April",
		"Month.5": "Maj",
		"Month.6": "Juni",
		"Month.7": "Juli",
		"Month.8": "Augusti",
		"Month.9": "September",
		"Month.10": "Oktober",
		"Month.11": "November",
		"Month.12": "December",
		"YourComputerLocalTime": "Din dators lokala tid är",
		"MoreOnHowYouUploadAnswerFiles": "Mer om hur du laddar upp offlinesvarsfiler",
		"Accessibility": "Tillgänglighet",
		"AccessibilitySettings": "Tillgänglighetsinställningar",
		"AllowSpellcheckForStudent": "Tillåt stavningskontroll för den här eleven",
		"City": "Stad",
		"State": "Stat",
		"Country": "Land",
		"YouHaveNotAddedRubricToExam.Saving": "Du har inte valt någon bedömningsmatris till provet.",
		"AbilitiesHaveNotBeenSelectedForAllQuestions.Saving": "Förmågor att mäta har inte valts för alla frågor.",
		"MergeSelectedOrganizations": "Slå ihop valda organisationer",
		"MergeSelectedOrganizations.Description": "Verktyg för att slå ihop organisationer.",
		"MergeSelectedOrganizations.SelectedOrganizations": "Valda organisationer att slå ihop:",
		"MergeSelectedOrganizations.MergeTo": "Välj organisation att slå ihop till:",
		"MergeSelectedOrganizations.Errors": "Kan ej slå ihop pga. följande fel:",
		"MergeSelectedOrganizations.OrgIdErrors": "Organisation är betalande kund:",
		"MergeSelectedOrganizations.mergeCheck.button": "Kontrollera sammanslagning",
		"MergeSelectedOrganizations.mergePossible.status": "Organisationerna går att slå ihop.",
		"MergeSelectedOrganizations.mergePayingPossible.status": "Organisationerna går att slå ihop. Men vald organisation är en betalande kund.",
		"MergeSelectedOrganizations.mergePossible.button": "Slå ihop",
		"MergeSelectedOrganizations.mergeDone.status": "Sammanslagning av organisationer startad. Du kommer att få ett mail när sammanslagningen är färdig.",
		"OrgId": "Organisations ID",
		"ResetLTICredentials": "Återställ LTI uppgifter",
		"EnableLTIIntegration": "Starta LTI integration",
		"DisableLTIIntegration": "Stoppa LTI integration",
		"Integrations": "Integrationer",
		"LTIIntegration": "LTI integration",
		"LTIIntegration.MoreInfo": "Läs mer om LTI integration",

		"Jobs": "Jobb",
		"Jobs.Id": "Jobb-ID",
		"Jobs.Details": "Jobbdetaljer",
		"Jobs.StartedBy": "Startades Av: ",
		"Jobs.Successful": "Lyckade: ",
		"Jobs.Skipped": "Skippade: ",
		"Jobs.StudentImport": "Elevimport",
		"Jobs.Status.Created": "Skapad",
		"Jobs.Status.Running": "Pågående",
		"Jobs.Status.Done": "Färdig",
		"Jobs.Status.Error": "fel: ogiltig status",
		"Jobs.ClearSearch": "Rensa sökning",
		"AccountManagerImports": "Importer",
		"AccountManagerImports.Title": "Importdetaljer",
		"AccountManagerImports.Id": "Import-id",
		"AccountManagerImports.NotFound": "Inga importer hittades",
		"AccountManagerImports.ImportStudents": "Importera elever",
		"AccountManagerImports.ImportingStudents": "Laddar importer..",
		"AccountManagerImports.ImportCounter": "{0} av {1} elever har importerats",
		"AccountManagerImports.Imported": "Importerade:",
		"AccountManagerImports.ImportedStudents": "Importerade Elever: ",
		"AccountManagerImports.DeletedStudents": "Elev med id {0} har tagits bort",
		"AccountManagerImports.DeletedStudents.Internal": "Elev med id {0} har tagits bort av personal på Digiexam",
		"AccountManagerImports.AccessibilitySettings": "Tillgänglighetsinställningar",
		"AccountManagerImports.Errors": "Fel: ",
		"AccountManagerImports.UnableToImport": "Kunde ej importeras({0})",
		"AccountManagerImports.SuccessfullyImported": "Importerad elevdata({0})",
		"AccountManagerImports.LoadError": "Det gick ej att ladda importinformation",
		"AccountManagerImports.LoadError.Student": "Det gick ej att ladda importinformation om elev {0}",
		"AccountManagerImports.Duplicate.Title": "Eleven existerar redan på {0}",
		"AccountManagerImports.Duplicate.Message": "Användaren {0} har redan en elev på {1}.",
		"AccountManagerImports.Duplicate.LoadError": "Det gick ej att ladda importfel",
		"AccountManagerImports.Placeholder.PasteStudents": "Klistra in studentdatan här",
		"AccountManagerImports.SelectOrganizationInfo": "Välj en organisation",
		"AccountManagerImports.UserId": "Användar ID",
		"AccountManagerImports.Status": "Status",
		"AccountManagerImports.Created": "Skapad",
		"AccountManagerImports.Option.Any": "Alla",
		"AccountManagerImports.Error.SomethingWentWrong": "Ett fel inträffade, var vänlig försök igen lite senare eller kontakta support.",

		"Node.Setting.StudentCode": "Använd studentkoder",
		"Node.Setting.StudentCode.MoreInfo": "Studentkoder är valfria och kan stängas av om de ej behövs. Om studentkoder stängs av kommer de ej visas i Digiexam och behövs inte när studenter skapas.",

		"Integrations.SAML": "SAML integration",
		"Integrations.SAML.Enable": "Aktivera SAML integration",
		"Integrations.SAML.Disable": "Deaktivera SAML integration",
		"Integrations.SAML.Skolfederation": "Skolfederation",
		"Integrations.SAML.Other": common.other,
		"Ingegrations.SAML.Upload": common.upload,
		"Integrations.SAML.Save": common.save,
		"Integrations.SAML.Remove": "Ta bort Identity Provider",
		"Integrations.SAML.UnitId": "Enhetskod",
		"Integrations.SAML.FileUpload.1": "Ladda upp en Identity Provider (IDP) metadata-fil.",
		"Integrations.SAML.FileUpload.2": "Släpp filen var som helst på sidan eller klicka i den här rutan.",
		"Integrations.SAML.SkolfederationSelect": "Identity Provider (IDP) från Skolfederation",
		"Integrations.SAML.ValidUntil": "Giltig till",
		"Integrations.SAML.Error.403": "Ett fel uppstod: Behörighet saknas.",
		"Integrations.SAML.IDPAlreadyInUse": "En IDP med detta entity id används redan av en annan organisation.",
		"Integrations.SAML.Error.Unhandled": "Ett okänt fel uppstod.",
		"Integrations.SAML.MoreInfo": "Läs mer om SAML integration",

		"Integrations.Skolon": "Skolon integration",
		"Integrations.Skolon.Enable": "Aktivera Skolon integration",
		"Integrations.Skolon.Disable": "Deaktivera Skolon integration",
		"Ingegrations.Skolon.Save": common.save,
		"Integrations.Skolon.SkolonId": "Skolon-ID",
		"Integrations.Skolon.WrongRegExp": "Ett Skolon-ID kan bara innehålla alfanumeriska tecken",
		"Integrations.Skolon.TooShort": "Ett Skolon-ID måste innehålla 50 tecken",
		"Integrations.Skolon.SaveSuccess": "Sparningen av Skolon-ID lyckades",
		"Integrations.Skolon.SaveError": "Ett fel uppstod under sparning av Skolon-ID",
		"Integrations.Skolon.SaveConflict": "Skolon ID't används redan av en annan organisation",
		"Integrations.Skolon.MoreInfo": "Läs mer om Skolon integration",

		"ExternalTools": "Externa verktyg",
		"ExternalTools.New": "Nytt externt verktyg",
		"ExternalTools.Create": "Skapa externt verktyg",
		"ExternalTools.TitleAdd": "Lägg till externt verktyg",
		"ExternalTools.MyTool": "Mitt verktyg",
		"ExternalTools.Existing": "Befintliga externa verktyg",
		"ExternalTools.Edit": "Redigera externt verktyg",
		"ExternalTools.Delete": "Ta bort externt verktyg",
		"ExternalTools.LandingPage": "Landingssida",
		"ExternalTools.LandingPageURL": "URL för landingssida",
		"ExternalTools.WholeDomain": "Hel domän",
		"ExternalTools.SingleWebPage": "Enskild webbsida",
		"ExternalTools.PartOfDomain": "Del av domän",
		"ExternalTools.AllowLists": "Listor över tillåtna webbplatser",
		"ExternalTools.AllowDomains": "Tillåt hela domäner",
		"ExternalTools.AllowSinglePages": "Tillåt enskilda webbsidor",
		"ExternalTools.AllowPartialDomainAccess": "Tillåt delvis åtkomst till domäner",
		"ExternalTools.AddURL": "Lägg till URL",
		"ExternalTools.StudentEquipmentChecks": "Kontroll av elevutrustning",
		"ExternalTools.Camera": "Kamera",
		"ExternalTools.Microphone": "Mikrofon",
		"ExternalTools.ScreenShare": "Skärmdelning",
		"ExternalTools.CanEditEquipment": "Lärare kan ange/redigera elevutrustning",
		"ExternalTools.CanEditLandingPage": "Lärare kan ange/redigera landningssida",
		"ExternalTools.ChangeIcon": "Byt ikon",
		"ExternalTools.Tooltip.New": "Externa verktyg är en funktion som gör det möjligt att använda olika webbapplikationer och webbplatser i prov som inte kan användas med medialänkar." +
			" Funktionen stöder till exempel webbplatser eller webbapplikationer som kräver att användaren loggar in.",
		"ExternalTools.Tooltip.Name": "Externa verktygets namn som kommer visas för eleven i Digiexam-klienten när provet genomförs.",
		"ExternalTools.Tooltip.LandingPageURL": "När det här externa verktyget används i ett prov så kommer det här vara den första sidan som eleven ser.",
		"ExternalTools.Tooltip.CanEditLandingPage.P1": "När den här inställningen är aktiv kan läraren redigera landningssidan när det externa verktyget läggs till i ett prov. ",
		"ExternalTools.Tooltip.CanEditLandingPage.P2": "Kontohanteraren kan också välja att lämna landningssidan tom när den här inställningen är aktiv," +
			" men det blir då obligatoriskt för läraren att lägga till en landningssida innan det externa verktyget kan användas i ett prov.",
		"ExternalTools.Tooltip.AllowLists.P1.title": "Tillåt enskilda webbsidor",
		"ExternalTools.Tooltip.AllowLists.P1.body": "Gör det möjligt för en elev att använda sig av den/de webbadresser som läggs till.",
		"ExternalTools.Tooltip.AllowLists.P2.title": "Tillåt hela domäner",
		"ExternalTools.Tooltip.AllowLists.P2.body": "Tillåter en elev att navigera fritt under den/de domäner som lagts till utan några begränsningar.",
		"ExternalTools.Tooltip.AllowLists.P3.title": "Tillåt delvis åtkomst till domäner",
		"ExternalTools.Tooltip.AllowLists.P3.body": "Tillåter en elev att navigera fritt under den angivna URL-sökvägen. Det är möjligt att navigera djupare inom samma sökväg så länge den inte ändras, det är dock inte möjligt att gå upp en nivå i sökvägen som anges här.",
		"ExternalTools.Tooltip.AllowList.LandingPage": "Det här är landningssidan, den läggs alltid till som en enskild webbsida.",
		"ExternalTools.InvalidURL": "Den angivna webbadressen är inte giltig",
		"ExternalTools.InvalidURLFormat": "Den angivna webbadressen har inte ett korrekt format",
		"ExternalTools.URLCouldNotBeReached": "Den angivna webbadressen kunde inte nås",
		"ExternalTools.URLAlreadyExists": "Den angivna webbadressen finns redan i listan",
		"ExternalTools.InvalidLandingPage": "Landningssidan är inte giltig",
		"ExternalTools.InvalidLandingPageFormat": "Landningssidan har inte ett korrekt format",
		"ExternalTools.LandingPageCouldNotBeReached": "Landningssidan kunde inte nås",
		"ExternalTools.Tooltip.StudentEquipmentChecks": "Aktivera kontroll av elevutrustning när externa verktyg som video- eller möteskonferenser används vilket kräver utrustning som kamera och / eller mikrofon." +
			" När de här inställningarna är aktiva kommer Digiexam att be elevens operativsystem om tillstånd att använda utrustningen under provtillfället.",
		"ExternalTools.InternetWarning": "Eleven måste vara ansluten till internet för att använda det externa verktyget.",
		"ExternalTools.DeleteWarning.Title": "Är du säker på att du vill ta bort {0}?",
		"ExternalTools.DeleteWarning.Body.UsedInTemplates": "Det här externa verktyget används i {0} provmallar. Det kommer fortfarande att finnas tillgängligt i aktiva och avslutade prov som det är aktiverat för.",
		"ExternalTools.DeleteWarning.Body.NotUsedInTemplates": "Efter att det här externa verktyget har tagits bort kommer det fortfarande att finnas tillgängligt i aktiva och avslutade prov som det är aktiverat för.",
		"ExternalTools.SuccessfullyAddedInfo": "Det externa verktyget har lagts till",
		"ExternalTools.SuccessfullySavedInfo": "Det externa verktyget har sparats",
		"ExternalTools.SuccessfullyDeletedInfo": "Det externa verktyget {0} har tagits bort",
		"ExternalTools.SuccessfullyAddedUrl": "URL:en {0} har lagts till",
		"ExternalTools.SuccessfullyAddedLandingPageUrl": "URL:en {0} för landningssidan har lagts till",
		"ExternalTools.CouldNotSaveError": "Ändringarna kunde inte sparas",
		"ExternalTools.CouldNotLoadError": "Det externa verktyget kunde inte laddas",
		"ExternalTools.CouldNotLoadError.Plural": "De externa verktygen kunde inte laddas",
		"ExternalTools.CouldNotDeleteError": "Det externa verktyget {0} kunde inte tas bort",
		"ExternalTools.EnterNameError": "Du behöver ange ett namn på verktyget för att spara",
		"ExternalTools.NameTooLongError": "Namnet på verktyget får inte vara längre än {0} tecken",
		"ExternalTools.EnterLandingPageError": "Du behöver ange en URL för landingssida för att spara",
		"ExternalTools.SetIcon": "Välj ikon för {0}",
		"ExternalTools.SomeDeletedWarning.Title": "Några externa verktyg har tagits bort",
		"ExternalTools.SomeDeletedWarning.Body": "Följande externa verktyg har tagits bort: <strong>{0}</strong>. De kommer inte längre kunna användas i framtida prov.",
		"ExternalTools.SomeDeletedWarning.OnExamStart": "Följande externa verktyg har tagits bort: <strong>{0}</strong>. De kommer inte vara tillgängliga i det här provet.",

		"ExternalToolSettings.EnterLandingPageError": "Du behöver ange en landningssida för externt verktyg \"{0}\".",

		"ExternallyManaged": "Hanteras externt",
		"ExternallyManagedExplanation": "Denna rollen hanteras i ett annat system utanför Digiexam. Du måste använda det andra systemet för att ändra på rollen och sedan dyker dom ändringarna upp i Digiexam nästa gång du loggar in i Digiexam via det systemet.",
		"OnlyExternallyManagedRolesExist": "Den här organizationen har roller som hanteras i ett annat system utanför Digiexam men inga roller som hanteras av Digiexam. Du kan inte bjuda in användare till externt hanterade roller i Digiexam.",
		"PrintSettings.Heading": "Utskriftsinställningar",
		"PrintSettings.HeadingClose": "Stäng utskriftsinställningar",
		"PrintSettings.PageBreaks.Title": "Sidbrytning",
		"PrintSettings.PageBreaks.Disabled": "Ingen sidbrytning",
		"PrintSettings.PageBreaks.ExamTitle": "Efter titel",
		"PrintSettings.PageBreaks.Student": "Innan varje elev",
		"PrintSettings.PageBreaks.Question": "Innan varje fråga",
		"PrintSettings.DoubleLineSpacing.Title": "Dubbelt radavstånd",
		"PrintSettings.DoubleLineSpacing.Description": "Visa en tom rad mellan varje rad av text.",
		"PrintSettings.AddBlankPage": "Separera med blank sida",
		"PrintSettings.SortBy.Students": common.students,
		"PrintSettings.SortBy.Questions": common.questions,
		"PrintSettings.ExcludeUnansweredQuestions.Title": "Exkludera obesvarade frågor",
		"PrintSettings.HideStudentNames.Title": "Dölj elevnamn",
		"PrintSettings.HideStudentNames.Description": "När elevnamn döljs ordnas elever om efter studentkod",
		"PrintSettings.NameSettings.Title": "Namninställningar",
		"PrintSettings.NameSettings.body1": "Minst ett alternativ behöver väljas. ",
		"PrintSettings.NameSettings.body2": "Om flera alternativ väljs följer de i ordningen:",
		"PrintError.Heading": "Fel vid utskrift",
		"PrintError.Info": "Ett fel inträffade när dokumentet skulle hämtas.",
		"EditClassName": "Ändra klassens namn",
		"EnterNewClassName": "Ange klassens nya namn",
		"NewClassName": "Nytt namn",
		"Referral.ReferFriends": "Tipsa vänner och kollegor",
		"Referral.ReferFriendsMotivation": "Bjud in dina vänner och kollegor att ta del av Digiexam!",
		"Referral.ShareLink": "Du kan även bjuda in genom att dela en länk:",
		"Referral.EmailsSendSuccessful": "Mailen är på väg! Tack för att du rekommenderar Digiexam!",
		"Referral.EmailsSendError": "Mailen kunde inte skickas på grund av ett tekniskt fel. Var vänlig försök igen. Om problemet kvarstår, vänligen kontakta support.",
		"Referral.MustBeValidEmail": "Måste vara en giltig e-postadress",
		"Referral.AtLeastOneEmailInvalid": "Minst en av e-postadresserna är inte giltig. Korrigera den ogiltiga e-postadressen innan du skickar.",
		"Referral.EnterAtLeastOneEmail": "Fyll i minst en e-postaddress innan du skickar.",
		"RandomizeTheOrderOfQuestions": "Slumpa ordningen på frågor",
		"RandomizeTheOrderOfAlternatives": "Slumpa ordningen på alternativ",
		"OpenBookExam": "Öppen bok prov",
		"AnonymousExam": "Anonymt prov",
		"StudentComputerLockdown": "Nedlåsning av studentens dator",
		"StudentComputerLockdown.Description.On": "Studenter kan inte söka information på webben eller använda andra program under provtillfället.",
		"StudentComputerLockdown.Description.Off": "Studenter kan söka information och använda andra program under provtillfället.",
		"StudentComputerLockdown.Help": "Studenter kan söka information på webben och använda andra program på datorn under provtillfället.",
		"StudentComputerLockdown.Info1": "I nedlåst läge har studenter ingen möjlighet att söka information på webben eller att använda andra program på datorn under provtillfället.",
		"StudentComputerLockdown.Info2": "Slå på för formella prov.",
		"StudentComputerLockdown.Info3": "Slå av för bedömningsuppgifter där studenter får söka information på webben och använda andra program.",
		"RemoteProctoringEnabled": "Fjärrövervakning",
		"RemoteProctoringEnabled.Info1": "Tillåter dig, provvakter och administratörer att se elevers webbkamera, mikrofon och skärm under ett pågående prov, samt även se inspelningar efter provet har avslutats.",
		"RemoteProctoringEnabled.Description": "Elevers aktivitet kommer övervakas och spelas in under pågående prov.",
		"AllowExternalPaste": "Tillåt att kopiera-klistra text i provet",
		"AllowExternalPaste.Info1": "Slå på för att tillåta eleverna att kopiera-klistra in text till sitt svar. I nedlåst läge kan endast text tillgänglig inuti provet (Publik provbeskrivning, Frågor och tillåtna länkar) användas.",

		"General": "Allmänt",
		"ExamSettings": "Provinställningar",
		"ExamSettingsInfo.Title": "Inställningar valda för detta prov",
		"ExamSettingsInfo.AnonymousExam.Title": "Anonymt prov",
		"ExamSettingsInfo.AnonymousExam.Info1": "Elevers/Studenters namn är inte synliga för lärare under rättningen. Användaren som startade provet äger rätten att låsa upp anonymiseringen när provet är rättat.",
		"ExamSettingsInfo.AnonymousExam.Info2": "För att stödja prov/tentor där anonym rättning är ett krav, bör provet/tentan startas från rollen som Administratör.",
		"ExamSettingsInfo.AnonymousExam.Description": "Studenters namn är inte synliga för lärare under rättningen.",
		"ExamSettingsInfo.DurationSetting.Title": "Tidsbegränsat prov",
		"ExamSettingsInfo.DurationSetting.Description": "Studenter måste lämna in {0} timmar och {1} minuter efter att de startat provet.",
		"ExamSettingsInfo.SpellcheckAllowedForAllStudents.Title": "Stavningskontroll tillåten",
		"ExamSettingsInfo.SpellcheckAllowedForAllStudents.Description": "Alla studenter har möjlighet att använda stavningskontroll under provtillfället.",
		"ExamSettingsInfo.SpellcheckAllowedForSelectedStudents.Title": "Stavningskontroll vid behov",
		"ExamSettingsInfo.SpellcheckAllowedForSelectedStudents.Description": "Utvalda studenter har möjlighet att använda stavningskontroll under provtillfället.",
		"ExamSettingsInfo.TextToSpeechAllowedForAllStudents.Title": "Talsyntes tillåten",
		"ExamSettingsInfo.TextToSpeechAllowedForAllStudents.Description": "Alla studenter har möjlighet att använda talsyntes under provtillfället.",
		"ExamSettingsInfo.TextToSpeechAllowedForSelectedStudents.Title": "Talsyntes vid behov",
		"ExamSettingsInfo.TextToSpeechAllowedForSelectedStudents.Description": "Utvalda studenter har möjlighet att använda talsyntes under provtillfället.",
		"ExamSettingsInfo.UsbAudioAllowedForAllStudents.Title": "Tillåt uppspelning av ljud från USB",
		"ExamSettingsInfo.UsbAudioAllowedForAllStudents.Description": "Alla studenter kan spela upp ljudfiler från USB under provtillfället.",
		"ExamSettingsInfo.UsbAudioAllowedForSelectedStudents.Title": "Tillåt uppspelning av ljud från USB vid behov.",
		"ExamSettingsInfo.UsbAudioAllowedForSelectedStudents.Description": "Utvalda studenter kan spela upp ljudfiler från USB under provtillfället.",
		"ExamSettingsInfo.ImmersiveReaderAllowedForAllStudents.Title": "Avancerad läsare tillåtet",
		"ExamSettingsInfo.ImmersiveReaderAllowedForAllStudents.Description": "Alla studenter har tillåtelse att använda Avancerad läsare.",
		"ExamSettingsInfo.ImmersiveReaderForSelectedStudents.Title": "Avancerad läsare är tillåtet vid behov.",
		"ExamSettingsInfo.ImmersiveReaderForSelectedStudents.Description": "Utvalda studenter kan använda Avancerad läsare.",
		"ExamSettingsInfo.randomizedQuestions.Title": "Slumpad ordning på frågor",
		"ExamSettingsInfo.randomizedQuestions.Description": "Ordningen på frågorna slumpas fram för studenterna under provtillfället.",
		"ExamSettingsInfo.randomizedQuestions.Info1": "Ordningen på frågorna slumpas fram för studenterna under provtillfället. Ordningen återställs innan du rättar provet.",
		"ExamSettingsInfo.randomizedAlternatives.Title": "Slumpad ordning på alternativ",
		"ExamSettingsInfo.randomizedAlternatives.Description": "Ordningen på alternativ i en- och flervalsfrågor slumpas fram för studenterna under provtillfället.",
		"ExamSettingsInfo.randomizedAlternatives.Info1": "Ordningen på alternativ i en- och flervalsfrågor slumpas fram för studenterna under provtillfället. Ordningen återställs innan du rättar provet.",
		"ExamSettingsInfo.lockedQuestionSequence.Title": "Låst frågeordning (MEQ)",
		"ExamSettingsInfo.lockedQuestionSequence.Description": "Ordningen på frågorna är låst i provet. En student kan inte gå tillbaka till en besvarad fråga för att redigera sitt svar.",
		"ExamSettingsInfo.ExternalTools.Title": "Tillåtna externa verktyg",
		"ExamSettingsInfo.AllowExternalPaste.Title": "Tillåt att kopiera-klistra text i provet",
		"ExamSettingsInfo.AllowExternalPaste.Info.On": "Elever kan kopiera-klistra från publik provbeskrivning, frågor och tillåtna länkar",
		"ExamSettingsInfo.AllowExternalPaste.Info.Off": "Elever kan inte kopiera-klistra från publik provbeskrivning, frågor och tillåtna länkar",

		"On": common.on,
		"Off": common.off,
		"ReadMore": "Läs mer",

		"Support.HowToUseDigiExam": "Användarguider för Digiexam",
		"Support.WeHaveUserGuides": "Vi har användarguider tillgängliga för lärare, studenter och administratörer som förklarar hur man kan använda Digiexam. Du kan även hitta annan dokumentation såsom systemkrav och installationsguider.",
		"Support.GoToKnowledgeCenter": "Gå till kunskapscentrum",
		"Support.DownloadClient": "Ladda ned klienten",
		"Support.AsAStudentYouNeed": "Som elev måste du ladda ner och installera klienten för Digiexam för att skriva ett prov. Om du är en lärare kan du ladda ner klienten för att testa att skriva ett prov från en elevs perspektiv.",
		"Support.GoToInstallationGuides": "Gå till installationsguider",
		"Support.ContactUs": "Kontakta oss",
		"Support.NeedMoreHelp.ChatWithUs": "Chatta med oss: Du finner chattbubblan nere i högra hörnet på sidan. (Om du inte ser denna, prova med att rensa cache i din webbläsare).",
		"Support.NeedMoreHelp.EmailUs": "Maila oss: Du når oss på <a href='{0}'>{1}</a>",
		"Support.ThisSupportFeatureIsOnly": "Den här tjänsten är tyvärr endast tillgänglig för betalande användare. Kontakta vårt säljteam för mer information på <a href='{0}'>{1}</a>",
		"Support.SalesMailSubject": "Basic till Premium",
		"Support.SalesMailBody": "Hej!\n\nJag vill bli kontaktad om prisförslag för Digiexam på min skola.\n\nNamn: \nTelefonnummer: \nSkola: \nBefattning: ",
		"Support.OrCheckOut1": "eller kolla in vårt",
		"Support.OrCheckOut2": "eller",
		"Support.DigiExamIntro": "Intro till Digiexam",
		"Support.PinInfo": "Denna PIN används för att verifiera din identitet när du kontaktar oss. Den uppdateras en gång om dagen.",
		"Support.Installations.Recommended": "Rekommenderad",
		"Support.Installations.ToolboxDescription": "Installerar och hanterar appen åt dig",
		"Support.Installations.Download": "Ladda ner",
		"Support.Installations.Guide": "Installationsguide",
		"Support.Error": "Supportchatten är nere för tillfället, försök igen eller kontakta support genom e-post: {0}",
		"Support.ContactAccountManager.Title": "Kontohanterare",
		"Support.ContactAccountManager.Content": "Behöver du skapa elever, bjuda in användare eller saknar du en roll? " +
			"Kontakta en kontohanterare på din skola/organisation.",
		"Support.ContactAccountManager.Empty": "Det finns ingen kontohanterare på din skola/organisation.",
		"Support.ContactAdmin.Title": "Administratör",
		"Support.ContactAdmin.Content": "Behöver du ta bort anonymisering av ett prov? Kontakta en administratör på din skola/organisation.",
		"Support.ContactAdmin.Empty": "Det finns inga administratörer på din skola/organisation.",

		"LTI.CouldNotSendAllGrades": "Kunde inte skicka alla betyg",
		"LTI.WeEncounteredProblems": "Tyvärr stötte vi på problem när vi skulle skicka betygen till din läroplattform. Betygen för följande elever kunde inte skickas och vi rekommenderar att du manuellt för in deras betyg i din läroplattform",
		"LTI.SelectedExam": "Valt prov",
		"LTI.FillInInYourLMS": "Fyll i detta i ditt LMS",
		"Course.LMSManaged.title": "Digiexam arbetar med ditt LMS",
		"Course.LMSManaged.paragraph.1": "Kurser från din läroplattform (Learning Management System, LMS) dyker upp här efter att du har använt Digiexam prov i dem.",
		"Course.LMSManaged.paragraph.2": "Välj en kurs för att se proven som du har använt och studenter som har registrerat sig för att skriva prov.",
		"Course.SkolonManaged.title": "Digiexam integrerar med Skolon",
		"Course.SkolonManaged.paragraph.1": "Dina Skolongrupper och elever synkas till Digiexam från Skolon när du loggar in. Du kan använda dessa grupper när du startar prov.",
		"Course.SkolonManaged.paragraph.2": "Ändringar för grupper (som att ta bort/lägga till elever eller lärare) måste ske i Skolon för att ändringarna skall tillämpas i Digiexam när du loggar in igen.",
		"Info": "Info",

		"NoExamSelected": "Inget prov valt",
		"ToSelectAnExam": "För att välja ett prov",
		"GotToSettingsForThisAssignmentInLMS": "Gå till inställningarna för den här uppgiften i din läroplattform",
		"ChooseDigiExamAsTheExternalTool": "Välj Digiexam som externt verktyg",
		"ChooseAnExamFromYourExamLibraryInDigiExam": "Välj ett prov ur ditt provbibliotek i Digiexam",
		"YouHaveNotStartedThisExamYet": "Du har inte startat provet ännu",
		"TipDoNotSetStartAndEndDatesInLMS": "Tips! Sätt inget start- och slutdatum i din läroplattform",
		"TipDoNotSetStartAndEndDatesInLMS.Info": "Om du lämnar start- och slutdatum blankt i din läroplattform så kommer studenter ha möjlighet att registrera sig för provet genom läroplattformen och få tillgång till sina inloggningsuppgifter i god tid innan du har startat provet. De kommer även kunna se betyg och återkoppling när provet är avslutat och du har publicerat resultatet.",
		"YouNeedToEndTheExamInDigiExam": "Du avslutar provet i Digiexam",
		"ViewExamInDigiExam": "Visa provet i Digiexam",
		"GradeExamInDigiExam": "Bedöm provet i Digiexam",
		"ResultsPublishedTo": "Resultaten har publicerats från Digiexam till",
		"WaitForYourTeacherToAddAnExam": "Vänta på att din lärare ska lägga till ett prov...",
		"LearnMoreAboutTakingAnExamInDigiExam": "Lär dig mer om hur prov i Digiexam fungerar",
		"IsOpenForRegistration": "är öppet för registrering",
		"RegisterMe": "Registrera mig",
		"WhenYouHaveRegistered.Info": "När du har registrerat dig får du tillgång till dina inloggningsuppgifter som du behöver för att kunna starta provet i Digiexam.",
		"UnableToRegister": "Fel vid registrering",
		"UnableToRegister.Info": "Du kunde inte registreras för det här provet.",
		"YouHaveRegisteredFor": "Du har blivit registrerad till",
		"YourTeacherWillLetYouKnow.Info": "Din lärare kommer meddela dig om när provet startar. För att skriva provet, öppna Digiexamklienten och ange dina personuppgifter:",
		"DontHaveTheClient": "Har du inte klienten?",
		"DownloadItHere": "Ladda ned den här",
		"YouHaveStarted": "Du har påbörjat",
		"ToContinueWritingTheExam.info": "För att fortsätta skriva provet, öppna Digiexamklienten. I vissa fall behöver din lärare låsa upp provet.",
		"YouHaveHandedInYourAnswersFor": "Du har lämnat in svar för ",
		"CheckBackHereLater.Info": "Kika in här senare för att se betyg och återkoppling från din lärare.",
		"HasEnded": "är avslutat",
		"FeedbackFromYourTeacher": "Återkoppling från din lärare",
		"SeeMoreDetailedFeedbackOnYourDigiExamAccount": "Se mer detaljerad återkoppling på ditt Digiexamkonto.",
		"GoToDigiExam": "Gå till Digiexam",
		"ExamAccessRestrictedToOwner": "Endast ägaren har tillgång till provet i Digiexam",
		"StartNow": "Starta nu",
		"Move": "Flytta till grupp",
		"MenuItem.Groups": "Grupper",
		"MenuItem.Rubrics": "Matriser",
		"MenuItem.RolesAndUsers": "Roller & Användare",
		"AddSelectedQuestions": "Lägg till valda frågor",

		"Overview.CreateExam": common.createNewExam,
		"StudentsAbsentOrUsedPenAndPaper": "Frånvarande eller använde papper & penna",
		"Update": "Uppdatering",
		"WebLinks": "Webblänkar",
		"WebLink": "Webblänk",

		"Region.Title": "Region",
		"Region.ChangeRegion": "ändra",
		"Region.ChooseRegion": "Välj region",
		"Region.Europe": "Europa",
		"Region.USA": "USA",
		"Region.Other": common.other,
		"Region.Development": "Dev",

		"Login.UserWrongRegionPopupTitle": "Ditt konto tillhör en annan region",
		"Login.UserWrongRegionPopupBody": "Det verkar som om ditt konto är registrerat på våra servrar i {0} så vi har bytt region åt dig. Var vänlig logga in igen.",
		"Login.TryAgain": "Försök igen",
		"Login.Europe": "Europa",

		"Exams.Exams": common.exams,
		"Exams.CreateExam": common.createNewExam,
		"Exams.Archive": common.archiveNoun,
		"Exams.ImportedExam": "Importerat prov",
		"Exams.SharedExam": "Delat prov",
		"Exams.SharedExamNotice": "Notera: Rättningen för detta prov är delat mellan flera lärare. Dina ändringar kan bli överskrivna av andra",
		"Exams.Import": "Importera",
		"Exams.Library": "Provbibliotek",
		"Exams.Scheduled": "Schemalagda",
		"Exams.Ongoing": "Pågående",
		"Exams.Ungraded": "Orättade",
		"Exams.Graded": "Rättade",
		"Exams.Published": "Publicerade",
		"Exams.ScheduledArchived": "Schemalagda (Arkiveras)",
		"Exams.OngoingArchived": "Pågående (Arkiveras)",
		"Exams.UngradedArchived": "Orättade (Arkiveras)",
		"Exams.GradedArchived": "Rättade (Arkiveras)",
		"Exams.PublishedArchived": "Publicerade (Arkiveras)",
		"Exams.Library.NoExams": "Ditt provbibliotek är tomt. Klicka på \"Skapa nytt prov\".",
		"Exams.Scheduled.NoExams": "Du har inga schemalagda prov.\nSchemalägg ett prov från provbiblioteket.",
		"Exams.Ongoing.NoExams": "Du har inga pågående prov.\nStarta ett prov från provbiblioteket.",
		"Exams.Ungraded.NoExams": "Du har inga orättade prov.",
		"Exams.Graded.NoExams": "Du har inga rättade prov.",
		"Exams.Published.NoExams": "Du har inga publicerade prov.",
		"Exams.OwnedBy": "Ägs av: ",
		"Exams.SharedWith": "Användare som har tillgång till: ",

		"Error.LoadingExams": "Det gick inte att hämta prov",
		"Error.LoadingInvigilatorSettings": "Det gick inte att hämta inställningar för provövervakare",
		"Error.Title": "Ojdå, något gick fel",
		"Error.Message": "Felmeddelande",
		"Error.SyncIssue": "Ett fel uppstod vid synkningen av data till Digiexam, se nedan för mer information om felet.",
		"Error.ContactUs": "Kontakta support@digiexam.se om du behöver support för att lösa problemet.",
		"Error.ContactUsSkolon": "Kontakta support@digiexam.se om du behöver support för att lösa problemet.",

		"Rubrics.Rubrics": common.rubrics,
		"Rubrics.CreateRubric": "+ Skapa ny matris",
		"Rubrics.Archive": common.archiveNoun,
		"Rubrics.RemoveRubric": "Ta bort bedömningsmatris",
		"Rubrics.Library.NoRubrics": "Ditt bibliotek är tomt, Klicka på “Skapa ny matris”.",
		"Rubrics.RemoveSharedRubric": "Ta bort delad bedömningsmatris",
		"Rubrics.ThePersonWhoSharedTheRubricWillStillHaveAccessToIt": "Personen som delade matrisen kommer fortfarande att ha tillgång till den.",

		"StartExamPopup.Start": "Starta",
		"StartExamPopup.StartTime": common.startTime,
		"StartExamPopup.Participants": "Deltagare",
		"StartExamPopup.UseExamID": "Använd prov-ID",
		"StartExamPopup.ChooseGroup": "Välj grupp",
		"StartExamPopup.StartExamNow": "Starta provet nu",
		"StartExamPopup.ScheduleExam": "Schemalägg prov",
		"StartExamPopup.TooltipExamIDStartNow": "Du får tillgång till ett prov-ID när du klickar på \"Starta provet nu\". Kom ihåg att lämna ut detta prov-ID till studenterna som ska skriva provet.",
		"StartExamPopup.TooltipExamIDSchedule": "Du får tillgång till ett prov-ID när du klickar på \"Schemalägg prov\". Kom ihåg att lämna ut detta prov-ID till studenterna som ska skriva provet.",
		"StartExamPopup.TooltipGroup": "Om du startar provet för en specifik grupp, dyker provet automatiskt upp för studenterna när de loggar in i klienten och de behöver inte ange ett prov-ID.",
		"StartExamPopup.LearnMore": "Läs mer",
		"StartExamPopup.CouldNotStartExam": "Kunde inte starta/schemalägga ditt prov.",
		"StartExamPopup.CouldNotLoadGroups": "Kunde inte ladda dina grupper.",
		"StartExamPopup.NoGroups": "Du har inte skapat några grupper.",
		"StartExamPopup.StartDateNeeded": "Du måste sätta ett startdatum.",
		"StartExamPopup.StartDateTooEarly": "Startdatum kan inte vara tidigare än nu.",
		"StartExamPopup.StartDateInvalid": "Datumet måste skrivas som \"YYYY-MM-DD\".",
		"StartExamPopup.StartNow": "Du håller på att starta",
		"StartExamPopup.For": "för",
		"StartExamPopUp.RequireInternetConnection": "Det här provet innehåller webblänkar. Eleven måste vara ansluten till internet för att komma åt innehållet på länkarna.",
		"StartExamPopup.IncompleteExam": "Denna provmall är inte komplett. Fyll i informationen som saknas för att kunna starta provet.",
		"StartExamPopup.EditExam": "Redigera provet",

		"EditExamPopup.ExistingExams.Title": "Befintliga prov",
		"EditExamPopup.ExistingExams.Body": "Du kommer att redigera provmallen. Befintliga prov som startats från mallen kommer inte att påverkas. Ändringar i provmallen kommer bara visas i nya schemalagda eller startade prov.",

		"Invigilator.TooltipInfo": "Provövervakaren får tillgång till att överblicka provet under dess planerade tid för att hjälpa läraren med administrationen. Du kan bestämma vilka funktioner provövervakaren ska ha tillgång till, så som starta/stoppa prov, låsa/låsa upp studenter, etc.",
		"Invigilator.InviteInvigilator": "Bjud in provövervakare",
		"Invigilator.InvigilatorInvitesPendingStartNow": "Inbjudningarna skickas när du klickar på \"Starta provet nu\".",
		"Invigilator.InvigilatorInvitesPendingSchedule": "Inbjudningarna skickas när du klickar på \"Schemalägg prov\".",
		"Invigilator.AddInvigilatorInvite": "Lägg till inbjudan",
		"Invigilator.PerformInvigilatorInvite": "Bjud in provövervakare",
		"Invigilator.PlannedInvigilatorInvites": "Inbjudningar till provövervakare",
		"Invigilator.PendingInvigilatorInvites": "Inbjudna provövervakare",
		"Invigilator.NoInvigilators": "Inga provövervakare bjudits in till provet",
		"Invigilator.Settings.Title": "Inställningar för provövervakare",
		"Invigilator.Settings.StartExam": "Starta prov",
		"Invigilator.Settings.EndExam": "Avsluta prov",
		"Invigilator.Settings.LockUnlockExam": "Låsa och låsa upp prov",
		"Invigilator.Settings.DownloadExam": "Ladda ned offlineprovfilen",
		"Invigilator.Error.AlreadyExists": "E-postadressen är redan tillagd",
		"Invigilator.Error.InvalidEmail": common.errors.invalidEmail,
		"Invigilator.Error.LoadError": "Kunde inte ladda provövervakare",
		"Invigilator.Error.CreateError": "kunde inte bjuda in provövervakare",
		"Invigilator.Save": "Spara ändringar för provövervakare",

		"ExamInfoPopup.HasStarted": "har startats",
		"ExamInfoPopup.HasBeenScheduled": "har schemalagts",
		"ExamInfoPopup.WillAutoStart": "kommer att starta automatiskt",
		"ExamInfoPopup.ShareExamId": "Du måste dela ut detta prov-ID till studenterna som ska skriva provet.",
		"ExamInfoPopup.YouHaveStarted": "Du har startat",
		"ExamInfoPopup.ForGroup": "för grupp",
		"ExamInfoPopup.Download": "Ladda ned offlineprovfilen",
		"ExamInfoPopup.At": "kl",
		"ExamInfoPopup.DownloadInfo1": "Spara offlinefilen för provet till ett USB-minne och ta med det till provtillfället. USB-minnet kan användas för att:",
		"ExamInfoPopup.DownloadInfo2": "- Starta ett prov för elever som inte kan starta online.",
		"ExamInfoPopup.DownloadInfo3": "- Ändra tillgänglighetsinställningar.",

		"Overview.SeeAllOngoingExams": "Visa alla pågående prov",
		"Overview.SeeAllUngradedExams": "Visa alla orättade prov",
		"Overview.SeeAllScheduledExams": "Visa alla schemalagda prov",

		"SearchSortFilter.Sort": "Sortera",
		"SearchSortFilter.DateModified": common.dateModified,
		"SearchSortFilter.Title": "Titel",
		"SearchSortFilter.Subject": "Ämne",
		"SearchSortFilter.Description": "Beskrivning",
		"SearchSortFilter.StartTime": common.startTime,
		"SearchSortFilter.FilterByTitleOrDescription": "Filtrera på titel eller beskrivning",
		"SearchSortFilter.FilterByTitleOrSubject": "Filtrera på titel eller ämne",
		"SearchSortFilter.FilterByTitleExamIDOrGroup": "Filtrera på titel, prov-ID eller grupp",

		"ExamEntry.DateModified": common.dateModified,
		"ExamEntry.StartTime": common.startTime,

		"RubricEntry.DateModified": common.dateModified,

		"Spellcheck.SettingField.Title": "Tillåt stavningskontroll för",
		"Spellcheck.SettingField.Tooltip": "Tillåt stavningskontroll för enskilda elever genom att klicka på \"Elever\" i vänstermenyn, hitta eleven och ändra detta under tillgänglighetsinställningar.",
		"Spellcheck.Setting.0": "Endast utvalda elever",
		"Spellcheck.Setting.1": "Alla elever",
		"Spellcheck.Setting.2": "Inga elever",

		"ExamAdminEmails.AddTitle": "Lägg till e-postadress till tenta-administratör",
		"ExamAdminEmails.Title": "E-postadresser till tenta-administratörer",

		"TotalSumCopy.Label": "Använd totalsumman",

		"Import.Title": "Importera prov och frågor",
		"Import.Paragraph.1": "Importera prov och frågor från en extern källa och använd i Digiexam. Importerade prov hamnar i ditt provbibliotek.",
		"Import.Paragraph.2": "För närvarande stödjer vi QTI 1.2, Common Cartridge (IMSCC) och Content package. Detta innebär att du kan importera frågor från bl.a. Canvas, Blackboard, Moodle, Sakai, Schoology och Powerschool.",
		"Import.Paragraph.3": "Vänligen notera att vi endast har stöd för frågetyper som kan importeras som fråga med flera val, flera rätta svar eller textfråga. Lär dig mer om hur du exporterar och importerar frågor i vårt",
		"Import.KnowledgeCenter": "Kunskapscentrum",
		"Import.DropArea.DropFilesHere": "Släpp filer här eller klicka för att bläddra.",
		"Import.DropArea.AllowedFileFormats": "Tillåtna filformat är .zip, .xml och .imscc",
		"Import.Results.Title": "Prov och frågor",
		"Import.Results.ExamTitle": "Provtitel",
		"Import.Results.ImportedQuestions": "Importerade frågor",
		"Import.Results.ViewReport": "Visa rapport",
		"Import.Results.ReportTitle": "Rapport för",
		"Import.Results.FilePath": "Filsökväg",
		"Import.Results.QuestionTitle": "Frågetitel",
		"Import.Results.ImportedAs": "Importerad som",
		"Import.Results.NotSupported": "Ej importerad: frågetyp stödjs ej",
		"Import.Results.CouldNotImport": "Ej importerad: frågan kunde inte läsas in",
		"Import.Importing": "Importerar",
		"Import.Restart": "Importera en fil till",
		"Import.ViewImported": "Visa importerade prov",

		"Uploadarea.InvalidFormat": "Följande filer har otillåtet filformat och kunde inte läggas till:",

		"QuestionType.UNIDENTIFIED": "Okänd frågetyp",
		"QuestionType.TRUE_FALSE": "Sant / Falskt",
		"QuestionType.MULTIPLE_RESPONSE": "Flera rätta svar",
		"QuestionType.MULTIPLE_CHOICE": "Flera rätta svar",
		"QuestionType.ESSAY": "Uppsats",
		"QuestionType.FILL_IN_BLANK": "Lucktext",
		"QuestionType.FILL_IN_MULTIPLE_BLANKS": "Flera lucktexter",
		"QuestionType.MULTIPLE_DROWDOWNS": "Flera dropdowns",
		"QuestionType.MATCHING": "Para ihop",
		"QuestionType.NUMERICAL": "Numeriskt svar",
		"QuestionType.CALCULATED": "Beräknad",
		"QuestionType.FILE_UPLOAD": "Ladda upp fil",
		"QuestionType.TEXT_ONLY": "Infotext",
		"QuestionType.EITHER_OR": "Antingen / Eller",
		"QuestionType.HOT_SPOT": "Hot spot",
		"QuestionType.OPINION_SCALE": "Skattningsskala",
		"QuestionType.ORDERING": "Ordna",
		"QuestionType.QUIZ_BOWL": "Svara med fråga",
		"QuestionType.SHORT_RESPONSE": "Kort svar",
		"QuestionType.AUDIO_RESPONSE": "Ljudinspelning",
		"QuestionType.SURVEY_MATRIX": "Frågematris",
		"QuestionType.PATTERN_MATCH": "Pattern match",

		"OnlineResourcePopup.Title": common.title,
		"OnlineResourcePopup.Cancel": common.cancel,
		"OnlineResourcePopup.Add": common.add,
		"OnlineResourcePopup.Edit": common.edit,
		"OnlineResourcePopup.SaveLink": common.save,
		"OnlineResourcePopup.AddLink": "Lägg till länk",
		"OnlineResourcePopup.WholeDomain": "Hela domänen",
		"OnlineResourcePopup.CloudDocument": "Molndokument",
		"OnlineResourcePopup.SingleWebPage": "Enskild webbsida",
		"OnlineResourcePopup.WebAddress": "Webbadress (URL)",
		"OnlineResourcePopup.RequireInternetConnection": "Eleven måste vara ansluten till internet för att komma åt innehållet på denna länk.",
		"OnlineResourcePopup.VideoLink": "YouTube-länk",
		"OnlineResourcePopup.AudioLink": "ljudlänk",
		"OnlineResourcePopup.PdfLink": "PDF-länk",
		"OnlineResourcePopup.WebPageLink": "webblänk",
		"OnlineResourcePopup.SingleWebPageTooltip": "Eleven har endast tillgång till sidan som du har valt. Eventuella länkar på sidan är blockerade och eleven är begränsad från möjlighet att navigera till andra sidor eller domäner.",
		"OnlineResourcePopup.CloudDocumentTooltip": "Studenten kan bara komma åt den sida du har valt. Den här typen av resurs tillåter omdirigering till målsidan, men länkar på sidan är blockerade och studenten är begränsad från att navigera till andra sidor eller domäner.",
		"OnlineResourcePopup.WholeDomainTooltip": "Eleven har tillgång till alla sidor på den valda domänen. Eventuella länkar som leder till sidor på andra domäner är blockerade.",
		"OnlineResourcePopup.TitleError": "Du måste ange en titel.",
		"OnlineResourcePopup.UrlErrorProtocol": "Du kan endast länka till en webbadress.",
		"OnlineResourcePopup.UrlErrorEmpty": "Du måste ange en URL.",
		"OnlineResourcePopup.YoutubeError": "Det är inte en YouTube video.",
		"OnlineResource.SuggestedTitle1": "Titelförslag: ",
		"OnlineResource.unreachableURL": "Vi kan inte nå webbadressen. Är du säker på att den är korrekt?",
		"OnlineResource.InternetWarning": "OBS: Elever behöver en internetuppkoppling för att använda medialänkar.",

		"OnlineResourceAddMedia.Audio": "Ljud",
		"OnlineResourceAddMedia.WebPage": "Webbsida",
		"OnlineResourceAddMedia.AddMedia": "Lägg till media",

		"OnlineResourceEntry.WholeDomain": "Hela domänen",
		"OnlineResourceEntry.SingleWebPage": "Enskild webbsida",
		"OnlineResourceEntry.CloudDocument": "Molndokument",
		"OnlineResourceEntry.Remove": common.remove,
		"OnlineResourceEntry.PopupTitle": "Viktig information",
		"OnlineResourceEntry.PopupDescription": "När studenten öppnar denna länk under provet kommer de inte kunna navigera till andra sidor.",
		"OnlineResourceEntry.IconAlt.YouTube": "YouTube-länk",
		"OnlineResourceEntry.IconAlt.Audio": "Ljudlänk",
		"OnlineResourceEntry.IconAlt.PDF": "PDF-länk",
		"OnlineResourceEntry.IconAlt.WebPage": "Webblänk",

		"StudentExtendedTime.Allow": "Tillåt förlängd provtid för prov med tidsgräns",
		"StudentExtendedTime.Limitless": "Ta bort tidsgräns",
		"StudentExtendedTime.Percent": "Förläng provtid med",

		"StudentRoute.Error.ExtendedTimePercentNotEntered": "Fyll i med hur många procent provtiden ska förlängas.",
		"StudentRoute.Error.ExtendedTimeStateNotSelected": "Ta bort tidsgräns eller förläng provtid med procent.",

		"TextToSpeech.SettingField.Title": "Tillåt talsyntes för",
		"TextToSpeech.SettingField.Tooltip": "Talsyntes gör det möjligt för eleven att lyssna på text. Tillåt talsyntes för enskilda elever genom att klicka på \"Elever\" i vänstermenyn, hitta eleven och ändra detta under tillgänglighetsinställningar.",
		"TextToSpeech.Setting.0": "Endast utvalda elever",
		"TextToSpeech.Setting.1": "Alla elever",
		"TextToSpeech.Setting.2": "Inga elever",
		"TextToSpeech.AllowForStudent": "Tillåt talsyntes för den här eleven",

		"ExamDuration.TimeLimit": "Tidsgräns",
		"ExamDuration.hours": "timmar",
		"ExamDuration.minutes": "minuter",
		"ExamDuration.AllowExtended": "Tillåt förlängd provtid för utvalda elever",
		"ExamDuration.TimeLimitToolTip": "Timern startar individuellt för varje elev när de startar provet. När timern tar slut lämnas provet automatiskt in. Läraren har möjlighet att förlänga eller ta bort tidsgränsen för enskilda elever under och efter provet. Detta görs med hjälp av en USB-enhet som innehåller offlineprovfilen (inte tillgängligt på iPad).",
		"ExamDuration.AllowExtendedToolTip": "För elever med särskilda behov finns det möjlighet att förlänga eller ta bort tidsgränsen. Gå till \"Elever\" i vänstermenyn, hitta eleven och ändra detta under tillgänglighetsinställningar.",
		"ExamDuration.ErrorMessage": "Tidsdgräns måste ha en tidsbegränsning längre än 0 minuter",
		"ExamDuration.On": common.on,
		"ExamDuration.Off": common.off,

		"UsbAudio.SettingField.Title": "Tillåt ljuduppspelning från USB-minne",
		"UsbAudio.SettingField.Tooltip": "Ljuduppspelning från USB-minne tillåter elever att lyssna på ljudfiler i klienten. Tillåt ljuduppspelning för enskilda elever genom att klicka på \"Elever\" i vänstermenyn, hitta eleven och ändra detta under tillgänglighetsinställningar.",
		"UsbAudio.Setting.0": "Endast utvalda elever",
		"UsbAudio.Setting.1": "Alla elever",
		"UsbAudio.Setting.2": "Inga elever",
		"UsbAudio.AllowForStudent": "Tillåt ljuduppspelning från USB-minne för eleven",

		"ImmersiveReader.SettingField.Title": "Tillåt Avancerad läsare för ",
		"ImmersiveReader.SettingField.Tooltip.RequireInternetConnection": "Eleven måste vara ansluten till internet för att använda Avancerad läsare.",
		"ImmersiveReader.SettingField.Tooltip.Description": "Avancerad läsare är ett inlärningsverktyg som erbjuder elever läshjälp visuellt, grammatiskt och verbalt. Tillåt Avancerad läsare för enskilda elever genom att klicka på \"Elever\" i vänstermenyn, hitta eleven och ändra detta under tillgänglighetsinställningar.",
		"ImmersiveReader.Setting.0": "Endast utvalda elever",
		"ImmersiveReader.Setting.1": "Alla elever",
		"ImmersiveReader.Setting.2": "Inga elever",
		"ImmersiveReader.AllowForStudent": "Tillåt Avancerad läsare att användas",

		"GradingOptions": "Rättningsalternativ",
		"GradingOptions.AllOrNothing": "Allt eller inget",
		"GradingOptions.AllOrNothing.Tooltip": "Eleven måste svara alla rätt för att få maxpoängen. Om eleven missar att svara på något eller svarar felaktigt på något, tilldelas eleven noll poäng.",
		"GradingOptions.RightMinusWrong": "Rätt minus fel",
		"GradingOptions.RightMinusWrong.Tooltip": "Eleven får pluspoäng för varje rätt svar och minuspoäng för varje felaktigt svar. Varje rätt svar är värt maxpoängen för frågan delat på antalet potentiellt rätta alternativ. Den lägsta poängen som tilldelas är noll.",
		"GradingOptions.PointsPerResponse": "Poäng per svar",
		"GradingOptions.PointsPerResponse.Tooltip": "Eleven får pluspoäng för varje rätt svar. Varje rätt svar är värt maxpoängen för frågan delat på antalet potentiellt rätta alternativ. Inga poäng dras av för fel svar. Den lägsta poängen som tilldelas är noll.",
		"GradingOptions.LimitedAlternatives": "Begränsade alternativ",
		"GradingOptions.LimitedAlternatives.Tooltip": "Begränsar hur många alternativ eleven/studenten kan välja när de besvarar frågan.",
		"GradingOptions.LimitedAlternatives.ChoiceLimit": "Begränsa antalet valbara alternativ till:",
		"GradingOptions.LimitedAlternatives.NumberOfAlternatives": "Antal alternativ",
		"GradingOptions.LimitedAlternatives.ChoiceLimit.Error": "Välj en begränsning",
		"GradingOptions.LimitedAlternatives.Error": "En av dina \"Flera rätta svar\"-frågor använder begränsade alternativ, men saknar begränsning.\n" +
		"Välj en begränsning eller stäng av begränsade alternativ för att lösa problemet.",

		"MasterTools.BulkChangeEmail.Verify": "Verifiera e-mail för bulk uppdatering",
		"MasterTools.BulkChangeEmail.Perform": "Genomför bulk uppdatering av e-mail",
		"MasterTools.BulkGdprDelete.Perform": "Genomför bulk GDPR borttagning",
		"MasterTools.BulkUnifyPassword.Perform": "Genomför bulk unify lösenord",

		"Communication.Title": "Kommunikationsinställningar",
		"Communication.Terms.Title": "Uppdateringar av tjänstevillkoren",
		"Communication.System.Title": "Systemnotiser",
		"Communication.ProductUpdates.Title": "Produktuppdateringar",
		"Communication.Promotional.Title": "Nyhetsutskick",

		"WordGap.MatchingOption.MatchingTitle": "Matchning",
		"WordGap.MatchingOption.CaseSensitive": "Skiftlägeskänsligt",
		"WordGap.MatchingOption.ExactMatch": "Exakt träff. Elevens svar måste vara exakt som det korrekta svaret.",
		"WordGap.MatchingOption.Contains": "Innehåller. Elevens svar måste innehålla det korrekta svaret.",
		"WordGap.Validation.NoBlanks": "Frågan måste innehålla minst en ordlucka.",
		"WordGap.Validation.EmptyBlanks": "Ordluckan får inte vara tom. Var god fyll i rätt svar.",

		"RedactedPii.StudentName": "[Borttagen student]",

		"Tooltip.Show": "Visa hjälpruta",
		"Tooltip.Note": "OBS!",
		"Tooltip.MoreInfo": "Mer information finns på Digiexams Kunskapscentrum",

		"Accessibility.Flags.DisableFilters": "Avaktivera filter",
		"Accessibility.Flags.Spellcheck": "Stavningskontroll",
		"Accessibility.Flags.TextToSpeech": "Talsyntes",
		"Accessibility.Flags.ExtendedTime": "Utökad tid",
		"Accessibility.Flags.ImmersiveReader": "Avancerad läsare",
		"Accessibility.Flags.AudioFiles": "Ljudfiler",
		"Accessibility.Header.UsedTools": "Tillgänglighetsverktyg använda under detta prov",
		"Accessibility.Header.UsedTools.WithName": "Tillgänglighetsverktyg använda av {0} under detta prov",

		"Navigation.SkipToMainContent": "Hoppa till huvudinnehållet",

		"LiveView.UnlockAll": "Lås upp alla",
		"LiveView.LockAll": "Lås alla",
		"LiveView.UnlockAll.Question": "Vill du låsa upp provet för alla studenter? Detta gäller alla elever i provet, även elever som döljs av filter.",
		"LiveView.LockAll.Question": "Vill du låsa provet för alla studenter? Detta gäller alla elever i provet, även elever som döljs av filter.",
		"LiveView.UnlockExam": "Lås upp prov",
		"LiveView.LockExam": "Lås prov",
		"LiveView.UnlockExam.Question": "Vill du låsa upp provet så eleven kan start det?",
		"LiveView.LockExam.Question": "Vill du låsa provet och hindra att eleven kan starta det?",
		"LiveView.Tooltip.LockedExamsTitle": "Låsstatus: Öppet och Låst",
		"LiveView.Tooltip.LockedExams": "En student kan bara starta ett prov som är öppet. Så fort studenten kommit in blir provet låst och det material och hjälpmedel som är tillåtna via provets inställningar är tillgängliga. När studenten lämnat in provet förblir det låst men studenten har inte längre tillgång till provet.",
		"LiveView.Tooltip.LockUnlockTitle": "Lås alla/Öppna alla",
		"LiveView.Tooltip.LockUnlock": "Använd funktionen för att låsa eller öppna alla prov med ett enda klick.",
		"LiveView.Tooltip.MoreInfo": "Läs mer om funktionen.",
		"LiveView.Forbidden": "Du har inte rätt behörighet att se provet.",

		"Schedule.Exam.Archive.Title": "Är du säker på att du vill arkivera {0}",
		"Schedule.Exam.Archive.Text": "Meddela eventuella provövervakare och elever om det avbrytna provtillfället.",

		"ArticleList.Blog": "Blogginlägg",
		"ArticleList.Blog.ShowAll": "Visa alla blogginlägg..",
		"ArticleList.Support": "Supportartiklar",
		"ArticleList.Support.ShowAll": "Visa alla artiklar..",
		"ArticleList.Updated": "Uppdaterad",
		"ArticleList.Created": "Skapad",
		"ArticleList.Title": "Titel",
		"ArticleList.NothingFound": "Inga artiklar hittades",
		"ArticleList.Error": "Det gick ej att ladda artiklarna",
		"ArticleList.New": "Ny",
		"ArticleList.ShowMore": "Visa fler..",
		"Grading.ScoreBasedValidation.ValidNumberError": "Endast nummer är tillåtna vid poängbaserad rättning",
		"Grading.ScoreBasedValidation.MinError": "Poängen får inte vara lägre än 0",
		"Grading.ScoreBasedValidation.MaxError": "Poängen får inte vara högre än frågans maxpoäng",

		"Archive.NoExamTemplates": "Det finns inga provmallar arkiverade",
		"Archive.NoLiveExams": "Det finns inga prov arkiverade",
		"Archive.NoRubrics": "Det finns inga bedömningsmatriser arkiverade",
		"Archive.NoCourses": "Det finns inga kurser arkiverade",
		"Archive.NoClasses": "Det finns inga klasser arkiverade",

		"Class.RemoveStudent": "Vill du verkligen ta bort \"{0}\" från {1}?",

		"ImportStudents.Title.Master": "Importera elever",
		"ImportStudents.Title.AccountManager": "Importera elever till {0}",
		"ImportStudents.SelectOrganization": "Välj organisation",
		"ImportStudents.StudentCodesDisabled": "Elevkoder används inte på denna organisation",
		"ImportStudents.Notice1": "Observera",
		"ImportStudents.Notice2": "Innan du skapar Digiexam-konton, kontrollera att e-postadresserna som ska användas för kontona är giltiga, aktiva och att de kan ta emot e-post.",
		"ImportStudents.Notice3": "Ett introduktionsmejl där lösenordet kan ställas in skickas ut när ett konto skapas." +
			"Om en e-postadress inte är giltig eller aktiv kan introduktionsmejlet inte tas emot och det kan heller inte skickas igen. " +
			"Introduktionsmejlet skickas ut oavsett om lösenord skapas av kontohanteraren eller inte vid import. ",
		"ImportStudents.Notice4": "En användare kan alltid använda \"Glömt lösenord\"-funktionen på inloggningsskärmen för att skapa ett nytt lösenord om de inte kan hitta introduktionsmejlet.",
		"ImportStudents.Details1": "Hur man importerar",
		"ImportStudents.Details2": "Klistra in elevinformationen från ett kalkylblad, formatera den som i exemplet nedan. Duplicerade " +
			"e-postadresser tas bort automatiskt. Tillgänglighetsinställningar kommer inaktiveras på användaren om de inte finns med. " +
			"Lösenord ställs in av användaren via introduktionsmejlet eller \"Glömt lösenord\"-funktionen om det inte läggs till här. ",
		"ImportStudents.Details3": "Aktivera en eller flera tillgänglighetsinställningar genom att inkludera rätt tillgänglighetskod. " +
			"Tillgänglighetsinställningar kan ändras när som helst från elevvyn.",
		"ImportStudents.AccessibilityCodes": "Tillgänglighetskoder",
		"ImportStudents.StudentCode": "Studentkod",
		"ImportStudents.PasteLabel": "Klistra in elever",
		"ImportStudents.Example.Title": "Formateringsexempel",
		"ImportStudents.Example.Show": "Visa exempel",
		"ImportStudents.Example.Hide": "Dölj exempel",
		"ImportStudents.Example.Details": "Elevinformation för Maria Olsson där talsyntes and stavningskontroll är aktiverat. Du kan prova formatet genom att kopiera och klistra in exemplet nedan.",
		"ImportStudents.Example.Email": "maria.olsson@mail.com",
		"ImportStudents.Example.FirstName": "Maria",
		"ImportStudents.Example.LastName": "Olsson",
		"ImportStudents.Example.StudentCode": "Olsson1234",
		"ImportStudents.Example.AccessibilityCodes": "tillgänglighetskoder*",
		"ImportStudents.Example.Optional.Note": "*valfritt att inkludera",
		"ImportStudents.Example.Password": "Ozqtge9D0y28",
		"ImportStudents.StudentsToImport": "Elever att importera",
		"ImportStudents.StudentsImportOngoing1": "Elevimport {0}, se jobb {1} för mer information.",
		"ImportStudents.StudentsImportOngoing2": "{0}/{1} elever importerade.",
		"ImportStudents.Error.InvalidEmail": "E-postadressen på rad {0} är inte giltig: {1}",
		"ImportStudents.Error.InvalidStudentCode": "Elevkoden på rad {0} är inte giltig: {1}",
		"ImportStudents.Error.InvalidFirstName": "Förnamnet på rad {0} är inte giltigt: {1}",
		"ImportStudents.Error.InvalidLastName": "Efternamnet på rad {0} är inte giltigt: {1}",
		"ImportStudents.Error.InvalidAccessibilityCode": "Tillgänglighetskod \"{0}\" på rad {1} är inte giltig: {2}",
		"ImportStudents.Error.InvalidPassword": "Lösenordet på rad {0} är inte giltigt: {1}",
		"ImportStudents.Error.InvalidColumnCount": "Rad {0} förväntades ha mellan {1} och {2} kolumner, men den hade {3}: {4}",
		"ImportStudents.Error.UnexpectedError": "Något gick fel under elevimporten, kontakta support om felet kvarstår.",
		"ImportStudents.Error.DuplicateEmails": "Samma e-postadress på rad: {0}",

		"CreateStudent.Error.UnexpectedError": "Något gick fel under elevskapandet, kontakta support om felet kvarstår.",
		"CreateStudent.Error.InvalidEmail": "E-postadressen är inte giltig",
		"CreateStudent.Error.InvalidStudentCode": "Elevkoden är inte giltig",
		"CreateStudent.Error.InvalidFirstName": "Förnamnet är inte giltigt",
		"CreateStudent.Error.InvalidLastName": "Efternamnet är inte giltigt",
		"CreateStudent.Error.AlreadyExists": "Eleven med denna e-postadress är redan registrerad",
		"CreateStudent.CreateSuccess": "Eleven har skapats,",
		"CreateStudent.CreateError": "Något blev blev fel när eleven skapades,",
		"CreateStudent.CreateLink": "klicka här för mer info.",

		"LeaveWarning.Title": "Är du säker på att du vill lämna denna sida?",
		"LeaveWarning.Body": "Ändringar som gjorts kommer inte att sparas.",

		"ProctoringSettings.Title": "Inställningar för fjärrövervakning",
		"ProctoringSettings.Warning": "Minst en inställning måste vara aktiverad.",
		"ProctoringSettings.Reset": "Återställ till standardinställningar",
		"ProctoringSettings.SaveSuccess": "Inställningarna sparade",
		"ProctoringSettings.MobileCamera.Title": "Extra mobilkamera",
		"ProctoringSettings.MobileCamera.Body": "Lägger till en kamera från en mobil/-smarttelefon i sessionen utöver webbkameran. Studenten ansluter en kamera från sin mobil/-smarttelefon med hjälp av en QR-kod.",
		"ProctoringSettings.AutomaticConclusion.Title": "Automatisk sessionsbedömning",
		"ProctoringSettings.AutomaticConclusion.Body1": "Systemet kan sätta en automatisk slutsats (positiv eller negativ) för varje session baserat på kriterierna som finns i inställningen “Spåra felanvändning”.",
		"ProctoringSettings.AutomaticConclusion.Body2": "Om inställningen “Spåra felanvändning” inte är aktiv så kommer alla sessioner automatiskt ges en positiv bedömning.",
		"ProctoringSettings.Chat.Title": "Elev och provvaktschat",
		"ProctoringSettings.Chat.Body": "Chatta med elever under provet. Det finns också stöd för fildelning i chatten.",
		"ProctoringSettings.FacePhoto.Title": "Fotografera ansikte vid provstart",
		"ProctoringSettings.FacePhoto.Body": "Eleven får en uppmaning att fotografera sitt ansikte när provet startas (om den här inställningen är inaktiverad fotograferas elevens ansikte automatiskt under de första minuterna efter att provet startat).",
		"ProctoringSettings.IdPhoto.Title": "Fotografera ID-kort vid provstart",
		"ProctoringSettings.IdPhoto.Body": "Eleven får en uppmaning att fotografera ett personligt ID-kort när provet startas.",
		"ProctoringSettings.RecordVideo.Title": "Spela in elevens skärm och webbkamera under provet",
		"ProctoringSettings.RecordVideo.Body1": "Under hela sessionen spelas video in från webbkameran, datorskärmen och mobilkamera.*",
		"ProctoringSettings.RecordVideo.Body2": "* Inspelning av mobilkamera kan endast göras om inställningen “Extra mobilkamera” är aktiverad",
		"ProctoringSettings.ScreenCapture.Title": "Visa elevens datorskärm under provet",
		"ProctoringSettings.ScreenCapture.Body": "Visar elevens datorskärm live under sessionen.",
		"ProctoringSettings.TrackMetrics.Title": "Spåra felanvändning",
		"ProctoringSettings.TrackMetrics.Body1": "Spårar indikationer på felaktig användning under provet baserat på följande kriterier:",
		"ProctoringSettings.TrackMetrics.Body2": "Om webbkameran är aktiv eller inaktiverad.",
		"ProctoringSettings.TrackMetrics.Body3": "Om elevens ansikte är täckt eller inte tittar in i webbkameran.",
		"ProctoringSettings.TrackMetrics.Body4": "Om det finns mer än ett ansikte framför webbkameran.",
		"ProctoringSettings.TrackMetrics.Body5": "Om elevens ansikte inte matchar fotografiet som togs i början av sessionen (ansiktet fotograferas automatiskt under de första minuterna efter sessionens början om ansiktsfoto vid provstart är inaktiverat).",
		"ProctoringSettings.TrackMetrics.Body6": "Om mikrofonen är avstängd eller dess volym är låg.",
		"ProctoringSettings.TrackMetrics.Body7": "Om det finns bakgrundsljud.",
		"ProctoringSettings.TrackMetrics.Body8": "Om det inte finns någon nätverksanslutning.",
		"NetworkAccess.Title": "Nätverksåtkomst",
		"NetworkAccess.Description": "Ange vilka publika IP-adresser och IP-intervall studenter får starta prov från.",
		"NetworkAccess.Error.LoadFailed": "Något gick fel när konfigurationen för nätverksåtkomst skulle hämtas.",
		"NetworkAccess.TryAgain": "Försök igen",
		"NetworkAccess.EmptyState": "Ingen nätverksbegränsning är konfigurerad. Studenter kan starta prov från vilket nätverk som helst.",
		"NetworkAccess.CreateConfiguration": "Skapa konfiguration",
		"NetworkAccess.RestrictionType.Title": "Begränsningstyp",
		"NetworkAccess.RestrictionType.LockdownExamsOnly.Title": "Endast nedlåsta prov",
		"NetworkAccess.RestrictionType.LockdownExamsOnly.Body": "Nätverksbegränsningen gäller endast när en student startar ett nedlåst prov.",
		"NetworkAccess.RestrictionType.AllExams.Title": "Alla prov",
		"NetworkAccess.RestrictionType.AllExams.Body": "Studenter kan endast starta prov från denna organisation från de nätverk som konfigurerats nedan.",
		"NetworkAccess.AllExamsWarning": "Studenter utanför de konfigurerade nätverken kommer inte att kunna starta prov från denna organisation.",
		"NetworkAccess.Entries.Title": "Tillåtna IP-adresser och intervall",
		"NetworkAccess.Entries.Type": "Typ",
		"NetworkAccess.Entries.Value": "Värde",
		"NetworkAccess.Entries.Description": "Beskrivning",
		"NetworkAccess.Entries.None": "Inga IP-adresser eller intervall har lagts till än.",
		"NetworkAccess.AddEntry": "Lägg till post",
		"NetworkAccess.EditEntry": "Redigera post",
		"NetworkAccess.EntryType.IPv4Address": "IPv4-adress",
		"NetworkAccess.EntryType.IPv6Address": "IPv6-adress",
		"NetworkAccess.EntryType.IPv4Range": "IPv4-intervall (CIDR)",
		"NetworkAccess.EntryType.IPv6Range": "IPv6-intervall (CIDR)",
		"NetworkAccess.DeleteConfiguration.Title": "Ta bort konfiguration",
		"NetworkAccess.DeleteConfiguration.Body": "Om du tar bort konfigurationen tas nätverksbegränsningen för denna organisation bort.",
		"NetworkAccess.DeleteConfiguration.Action": "Ta bort konfiguration",
		"NetworkAccess.ConfirmAllExams.Title": "Vill du begränsa alla prov med nätverk?",
		"NetworkAccess.ConfirmAllExams.Body": "Detta tillämpar nätverksbegränsningen på alla prov från denna organisation, inte bara nedlåsta prov.",
		"NetworkAccess.ConfirmDeleteEntry.Title": "Vill du ta bort denna post?",
		"NetworkAccess.ConfirmDeleteEntry.Body": "Denna IP-adress eller detta intervall kommer inte längre tillåtas starta prov.",
		"NetworkAccess.ConfirmDeleteLastEntry.Title": "Vill du ta bort den sista posten?",
		"NetworkAccess.ConfirmDeleteLastEntry.Body": "Detta är den sista posten i konfigurationen. Om du tar bort den raderas hela konfigurationen för nätverksåtkomst.",
		"NetworkAccess.ConfirmDeleteConfiguration.Title": "Vill du radera konfigurationen för nätverksåtkomst?",
		"NetworkAccess.ConfirmDeleteConfiguration.Body": "Detta tar bort nätverksbegränsningen för denna organisation. Studenter kommer att kunna starta prov från vilket nätverk som helst.",
		"NetworkAccess.Error.EmptyConfiguration": "Lägg till minst en IP-adress eller ett intervall innan du sparar.",
		"NetworkAccess.Error.InvalidEntryValue": "Ange en giltig IP-adress eller ett giltigt CIDR-intervall för den valda typen.",
		"NetworkAccess.Error.DuplicateEntry": "Denna IP-adress eller detta intervall har redan lagts till.",
		"NetworkAccess.Error.Unknown": "Något gick fel. Försök igen.",
		"Chromebook.LoginTitle": "Chromebook-inloggning",
		"Chromebook.TeacherDescription": "Generera en tillfällig PIN-kod för att autentisera den här eleven i Digiexam-appen.",
		"Chromebook.StudentDescription": "Om du använder en skolhanterad Chromebook, använd koden nedan för att autentisera dig i Digiexam-appen.",
		"Chromebook.GeneratePin": "Generera PIN-kod",
		"Chromebook.GenerateNewPin": "Generera ny PIN-kod",
		"Chromebook.Copied": "Kopierad!",
		"Chromebook.Code": "Kod:",
		"Chromebook.ExpiresIn": "(Går ut om {0})",
		"Chromebook.PinError": "PIN-koden kan inte genereras.",
		"Chromebook.TryAgain": "Försök igen",
	};
}());
